import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../context/AuthContext'; // ✅ FIXED PATH
import styles from "./DashboardPage.module.css";
import stoneforexLogo from '../../assets/stoneforex-logo.png';
import TradingAccountModal from "../../../../components/TradingAccountModal/TradingAccountModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTachometerAlt, faUserTie, faExchangeAlt, faFlask, faPercentage, faUserFriends,
  faArrowDown, faArrowUp, faRetweet, faListAlt, faLifeRing,
  faShieldAlt, faUser, faSun, faMoon, faRobot, faDesktop, faMobileAlt, faGlobe, faDownload, faPlay,
  faEye, faEyeSlash  // ✅ ADD THESE TWO ICONS
} from '@fortawesome/free-solid-svg-icons';

const navItems = [
  { label: "Dashboard", icon: faTachometerAlt },
  { label: "My IB Area", icon: faUserTie },
  { label: "Trade Accounts", icon: faExchangeAlt },
  { label: "Demo Accounts", icon: faFlask },
  { label: "Commissions", icon: faPercentage },
  { label: "My Referrals", icon: faUserFriends },
  { label: "Deposit", icon: faArrowDown },
  { label: "Withdraw", icon: faArrowUp },
  { label: "Balance Transfer", icon: faRetweet },
  { label: "Transactions", icon: faListAlt },
  { label: "Support Ticket", icon: faLifeRing },
  { label: "2FA", icon: faShieldAlt },
  { label: "Profile", icon: faUser },
  { label: "Change Password" },
  { label: "Logout" },
];

const TRADE_ACCOUNTS_INDEX = 2;
const DEMO_ACCOUNTS_INDEX = 3;
const COMMISSIONS_INDEX = 4;
const REFERRALS_INDEX = 5;
const DEPOSIT_INDEX = 6;
const WITHDRAW_INDEX = 7;
const BALANCE_TRANSFER_INDEX = 8;
const TRANSACTIONS_INDEX = 9;
const TWO_FA_INDEX = 11;
const PROFILE_INDEX = 12;
const CHANGE_PASSWORD_INDEX = 13;
const MYIBAREAINDEX = 1;          // ✅ ADD THIS
const SUPPORTTICKETINDEX = 10;    // ✅ ADD THIS


const API_BASE_URL = "https://final-project-5ar7.onrender.com";

console.log('🌐 DASHBOARD API_BASE_URL:', API_BASE_URL); // ✅ ADD THIS


function DashboardPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [activeNavIndex, setActiveNavIndex] = useState(0);
  const [darkMode, setDarkMode] = useState(false);
  const [showKycForm, setShowKycForm] = useState(false);
  
  // Trading accounts and balance states
  const [tradeAccounts, setTradeAccounts] = useState([]);
  const [userBalance, setUserBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  
  // Modal states
  const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);
  const [accountRequests, setAccountRequests] = useState([]);

  // KYC and withdrawal mode states
  const [userKycStatus, setUserKycStatus] = useState(null);
  const [withdrawalMode, setWithdrawalMode] = useState('');
  const [withdrawalStep, setWithdrawalStep] = useState('method');
  const [selectedWithdrawalMethod, setSelectedWithdrawalMethod] = useState('');
  const [selectedCryptoCountry, setSelectedCryptoCountry] = useState('');
  const [selectedWallet, setSelectedWallet] = useState('');

  // Transaction history states
  const [deposits, setDeposits] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);
// ✅ UPI Gateway state
const [upiGateways, setUpiGateways] = useState([]);
const [upiLoading, setUpiLoading] = useState(false);
const [showBankModal, setShowBankModal] = useState(false);
const [showCryptoModal, setShowCryptoModal] = useState(false);
const [cryptoGateways, setCryptoGateways] = useState([]);
const [selectedCryptoGateway, setSelectedCryptoGateway] = useState(null);
const [cryptoLoading, setCryptoLoading] = useState(false);
const [cryptoAvailable, setCryptoAvailable] = useState(false);
const [copiedCryptoAddress, setCopiedCryptoAddress] = useState(false);
const [bankLoading, setBankLoading] = useState(false);
const [bankAvailable, setBankAvailable] = useState(false);
const [bankGateways, setBankGateways] = useState([]);
const [selectedBankGateway, setSelectedBankGateway] = useState(null);
const [upiAvailable, setUpiAvailable] = useState(null); // null=not checked, true/false
const [selectedUpiGateway, setSelectedUpiGateway] = useState(null);
const [showUpiModal, setShowUpiModal] = useState(false);
const [copiedUpiId, setCopiedUpiId] = useState(false);
const [currentDepositId, setCurrentDepositId] = useState(null);
const [utrNumber, setUtrNumber] = useState('');
const [utrSlip, setUtrSlip] = useState(null);
const [slipUploading, setSlipUploading] = useState(false);
const [slipSubmitted, setSlipSubmitted] = useState(false);
  // Form states for deposits and withdrawals
  const [depositForm, setDepositForm] = useState({
    gateway: '',
    tradeAccount: '',
    amount: '',
    receipt: null
  });
const [visiblePasswords, setVisiblePasswords] = useState({}); // ✅ ADD THIS

  // Enhanced withdrawal form with PIN and crypto details
  const [withdrawForm, setWithdrawForm] = useState({
    tradeAccount: '',
    amount: '',
    fullName: '',
    whatsappNumber: '',
    gender: '',
    identityProof: null,
    proofOfResidence: null,
    tradingExperience: '',
    tradingExperienceDetails: '',
    withdrawalPin: '',
    cryptoWalletId: '',
    binanceId: ''
  });
// ✅ KYC form state — MUST be here, not after return
  const [kycForm, setKycForm] = useState({
    fullName: '',
    whatsappNumber: '',
    gender: '',
    identityProof: null,
    proofOfResidence: null,
    tradingExperience: '',
    tradingExperienceDetails: ''
  });
  // Change password form states
  const [changePasswordForm, setChangePasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  // Referral system data
  const [referralData, setReferralData] = useState({
    level: 1,
    totalReferrals: 0,
    commission: 0,
    referrals: []
  });
  // ✅ NEW: Real-time balance sync states
const [realTimeBalance, setRealTimeBalance] = useState({
  totalBalance: 0,
  totalEquity: 0,
  totalFreeMargin: 0,
  totalTradingBalance: 0
});
const [balanceRefreshInterval, setBalanceRefreshInterval] = useState(null);


  const toggleDarkMode = () => setDarkMode(!darkMode);

  // Handle MetaTrader platform navigation
  const handleMetaTraderLogin = () => {
    console.log('🚀 MetaTrader Launch clicked');
    console.log('👤 Current user:', user);
    console.log('📊 Trade accounts:', tradeAccounts);
    
    const approvedAccounts = tradeAccounts.filter(acc => acc.adminStatus === 'approved');
    console.log('✅ Approved accounts:', approvedAccounts);
    
    if (approvedAccounts.length === 0) {
      alert('❌ No approved trading accounts found.\n\nPlease create and get approval for at least one trading account to use MetaTrader 5.');
      setActiveNavIndex(TRADE_ACCOUNTS_INDEX);
      return;
    }
    
    localStorage.setItem('metatraderUser', JSON.stringify({
      id: user.id,
      email: user.email,
      name: user.name
    }));
    
    console.log('🔄 Navigating to MetaTrader login...');
    navigate('/metatrader-login');
  };

  // Initialize user session from AuthContext
  useEffect(() => {
    console.log('🎯 DASHBOARD DEBUG - AuthContext user:', user);
    console.log('🎯 DASHBOARD DEBUG - User ID should be:', user?.id);
    
    if (!user) {
      console.error('❌ No user session found in dashboard');
      alert('❌ Session expired. Please login again.');
      navigate('/login');
      return;
    }

    console.log('🔍 Dashboard initializing user session:', {
      userId: user.id,
      userEmail: user.email,
      userName: user.name,
      hasToken: !!user.token
    });
  }, [user, navigate]);

  // Check KYC status when user loads
  useEffect(() => {
    const checkKycStatus = async () => {
      if (!user?.id) return;
      
      try {
        const response = await fetch(`${API_BASE_URL}/api/transactions/check-kyc-status/${user.id}`);

        const data = await response.json();
        
        console.log('🔍 KYC Status:', data);
        setUserKycStatus(data);
        
        if (data.isApproved) {
          setWithdrawalMode('repeat_id_verification');
        } else {
          setWithdrawalMode('');
        }
      } catch (error) {
        console.error('❌ Error checking KYC status:', error);
      }
    };

    checkKycStatus();
  }, [user]);

  // Fetch user's trading accounts
  useEffect(() => {
    const fetchUserTradingData = async () => {
      if (!user?.id) return;

      try {
        setLoading(true);
        
        console.log('🔍 Fetching trading data for user:', user.id);
        
        const [accountsResponse, requestsResponse] = await Promise.all([
          fetch(`${API_BASE_URL}/api/admin/public/user-trading-accounts/${user.id}`),
fetch(`${API_BASE_URL}/api/admin/public/user-account-requests/${user.id}`)
        ]);
        
        const accountsData = await accountsResponse.json();
        const requestsData = await requestsResponse.json();
        
        console.log('📊 User trading accounts received:', accountsData);
        console.log('📋 User account requests received:', requestsData);
        
        if (Array.isArray(accountsData)) {
          setTradeAccounts(accountsData);
          
          // ✅ NEW: Enhanced balance calculations for dashboard
const totalBalance = accountsData
  .filter(account => account.adminStatus === 'approved')
  .reduce((sum, account) => sum + parseFloat(account.balance || 0), 0);

const totalEquity = accountsData
  .filter(account => account.adminStatus === 'approved')
  .reduce((sum, account) => sum + parseFloat(account.equity || account.balance || 0), 0);

const totalFreeMargin = accountsData
  .filter(account => account.adminStatus === 'approved')
  .reduce((sum, account) => sum + parseFloat(account.freeMargin || account.equity || account.balance || 0), 0);
// ✅ FIXED: Total Trading Balance = Only Account Balance (no Free Margin added)
const totalTradingBalance = totalBalance;

setUserBalance(totalTradingBalance); // ✅ Shows only account balance

console.log('✅ Enhanced balance calculations:', {
  totalBalance,
  totalEquity, 
  totalFreeMargin,
  totalTradingBalance
});

          console.log('💰 Calculated user balance from approved accounts:', totalBalance);
        }
        
        if (Array.isArray(requestsData)) {
          setAccountRequests(requestsData);
        }

        await fetchTransactionHistory();
        
      } catch (error) {
        console.error('❌ Error fetching user trading data:', error);
        setTradeAccounts([]);
        setAccountRequests([]);
        setUserBalance(0);
      } finally {
        setLoading(false);
      }
    };

    fetchUserTradingData();
  }, [user]);
const syncRealTimeBalances = async () => {
  if (!user?.id) return;
  
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/public/user-trading-accounts/${user.id}`);
    const accountsData = await response.json();
    
    if (Array.isArray(accountsData)) {
      const approvedAccounts = accountsData.filter(account => account.adminStatus === 'approved');
      
      const totalBalance = approvedAccounts.reduce((sum, account) => sum + parseFloat(account.balance || 0), 0);
      const totalEquity = approvedAccounts.reduce((sum, account) => sum + parseFloat(account.equity || account.balance || 0), 0);
      const totalFreeMargin = approvedAccounts.reduce((sum, account) => sum + parseFloat(account.freeMargin || account.equity || account.balance || 0), 0);
      const totalTradingBalance = totalBalance;

      // ✅ Only update state if values actually changed
      setRealTimeBalance(prev => {
        if (prev.totalBalance === totalBalance && prev.totalEquity === totalEquity && prev.totalFreeMargin === totalFreeMargin) {
          return prev; // no change, no re-render
        }
        return { totalBalance, totalEquity, totalFreeMargin, totalTradingBalance };
      });

      setUserBalance(prev => prev === totalTradingBalance ? prev : totalTradingBalance);
    }
  } catch (error) {
    console.error('Error syncing real-time balances:', error);
  }
};
const fetchCryptoGateways = async () => {
  setCryptoLoading(true);
  try {
    const res = await fetch(`${API_BASE_URL}/api/admin/public/crypto-gateway-for-user/${user.id}`);
    const data = await res.json();
    console.log('₿ Crypto gateways loaded:', data);
    if (data.success && data.available && data.gateways.length > 0) {
      setCryptoGateways(data.gateways);
      setSelectedCryptoGateway(data.gateways[0]);
      setCryptoAvailable(true);
    } else {
      setCryptoAvailable(false);
    }
  } catch (err) {
    console.error('❌ fetchCryptoGateways error:', err);
    setCryptoAvailable(false);
  } finally {
    setCryptoLoading(false);
  }
};
const fetchBankGateways = async () => {
  if (!user?.id) return;
  setBankLoading(true);
  try {
    const res = await fetch(`${API_BASE_URL}/api/admin/public/bank-gateway-for-user/${user.id}`);
    const data = await res.json();
    if (data.success) {
      setBankAvailable(data.available);
      setBankGateways(data.gateways || []);
      if (data.gateways?.length > 0) setSelectedBankGateway(data.gateways[0]);
    } else { setBankAvailable(false); }
  } catch (e) {
    console.error('❌ Bank fetch error:', e);
    setBankAvailable(false);
  }
  setBankLoading(false);
};
// ✅ Fetch UPI gateways for this user
const fetchUpiGateways = async () => {
  if (!user?.id) return;
  setUpiLoading(true);
  try {
    const res = await fetch(`${API_BASE_URL}/api/admin/public/upi-gateway-for-user/${user.id}`);
    const data = await res.json();
    if (data.success) {
      setUpiAvailable(data.available);
      setUpiGateways(data.gateways || []);
      if (data.gateways?.length > 0) setSelectedUpiGateway(data.gateways[0]);
    } else {
      setUpiAvailable(false);
    }
  } catch (e) {
    console.error('❌ UPI fetch error:', e);
    setUpiAvailable(false);
  }
  setUpiLoading(false);
};
  // Fetch transaction history
  const fetchTransactionHistory = async () => {
    if (!user?.id) return;
    
    try {
      const [depositsRes, withdrawalsRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/transactions/user-deposits/${user.id}`),
fetch(`${API_BASE_URL}/api/transactions/user-withdrawals/${user.id}`)
      ]);
      
      if (depositsRes.ok) {
        const depositsData = await depositsRes.json();
        setDeposits(Array.isArray(depositsData) ? depositsData : []);
        console.log('💰 User deposits loaded:', depositsData);
      }
      
      if (withdrawalsRes.ok) {
        const withdrawalsData = await withdrawalsRes.json();
        setWithdrawals(Array.isArray(withdrawalsData) ? withdrawalsData : []);
        console.log('💸 User withdrawals loaded:', withdrawalsData);
      }
    } catch (error) {
      console.error('❌ Error fetching transaction history:', error);
    }
  };

  // Handle deposit form submission
  const handleDepositSubmit = async (e) => {
    e.preventDefault();
    
    if (!depositForm.gateway || !depositForm.tradeAccount || !depositForm.amount) {
      alert('❌ Please fill in all required fields');
      return;
    }

    const amt = parseFloat(depositForm.amount);

    // ✅ Show payment modal based on gateway — fetch details then open
    if (depositForm.gateway === 'indian_upi') {
      if (amt < 10) { alert('❌ Minimum deposit is $10'); return; }
    } else if (depositForm.gateway === 'bank_transfer') {
      if (amt < 10) { alert('❌ Minimum deposit is $10'); return; }
    } else if (depositForm.gateway === 'crypto_usdt') {
      if (amt < 100) { alert('❌ Minimum deposit for Crypto USDT is $100'); return; }
    }

    // ✅ Submit to backend FIRST for all gateways
    try {
      const formData = new FormData();
      formData.append('userId', user.id);
      formData.append('tradeAccount', depositForm.tradeAccount);
      formData.append('amount', amt);
      formData.append('gateway', depositForm.gateway);
      formData.append('status', 'submitted');

      const response = await fetch(`${API_BASE_URL}/api/transactions/submit-deposit`, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const error = await response.json();
        alert(`❌ Failed to submit deposit: ${error.message}`);
        return;
      }

     const depositResult = await response.json();
      setCurrentDepositId(depositResult.deposit?.id || null);
      setUtrNumber('');
      setUtrSlip(null);
      setSlipSubmitted(false);

      await fetchTransactionHistory();

      // ✅ Now open the payment details modal
      if (depositForm.gateway === 'indian_upi') {
        await fetchUpiGateways();
        setShowUpiModal(true);
      } else if (depositForm.gateway === 'bank_transfer') {
        await fetchBankGateways();
        setShowBankModal(true);
      } else if (depositForm.gateway === 'crypto_usdt') {
        await fetchCryptoGateways();
        setShowCryptoModal(true);
      } else {
        alert('✅ Deposit request submitted! Admin will review your request.');
        setDepositForm({ gateway: '', tradeAccount: '', amount: '', receipt: null });
      }

    } catch (error) {
      console.error('❌ Error submitting deposit:', error);
      alert('❌ Network error. Please try again.');
    }
  };
  // ✅ Submit UTR + payment slip after UPI payment
const handleSubmitPaymentProof = async () => {
  if (!utrNumber.trim() && !utrSlip) {
    alert('❌ Please enter UTR/Reference number or upload payment slip');
    return;
  }
  if (!currentDepositId) {
    alert('❌ Deposit ID missing. Please try again.');
    return;
  }

  setSlipUploading(true);
  try {
    const formData = new FormData();
    if (utrNumber.trim()) formData.append('utrNumber', utrNumber.trim());
    if (utrSlip) formData.append('paymentSlip', utrSlip);

    const response = await fetch(`${API_BASE_URL}/api/transactions/update-deposit-proof/${currentDepositId}`, {
      method: 'PUT',
      body: formData
    });

    if (response.ok) {
      setSlipSubmitted(true);
      await fetchTransactionHistory();
      console.log('✅ Payment proof submitted');
    } else {
      const err = await response.json();
      alert(`❌ Failed to submit proof: ${err.message}`);
    }
  } catch (error) {
    console.error('❌ Error submitting payment proof:', error);
    alert('❌ Network error. Please try again.');
  } finally {
    setSlipUploading(false);
  }
};

  // Handle withdrawal form submission
  const handleWithdrawSubmit = async (e) => {
  e.preventDefault();
  
  console.log('🚀 Withdrawal submit started');
  console.log('📊 User data:', user);
  console.log('📝 Withdraw form:', withdrawForm);
  
  if (!withdrawForm.tradeAccount || !withdrawForm.amount) {
    alert('❌ Please fill in trade account and amount');
    return;
  }

const withdrawalAmount = parseFloat(withdrawForm.amount || 0);
if (withdrawalAmount <= 0) {
  alert('❌ Please enter a valid withdrawal amount');
  return;
}
if (withdrawalAmount < 10) {
  alert('❌ Minimum withdrawal amount is $10 USD');
  return;
}

if (withdrawalMode === 'repeat_id_verification') {
  if (!withdrawForm.identityProof || !withdrawForm.withdrawalPin) {
    alert('❌ Please upload your identity proof and enter PIN');
    return;
  }
  if (withdrawForm.withdrawalPin.length < 4) {
    alert('❌ Withdrawal PIN must be at least 4 digits');
    return;
  }
} else if (withdrawalMode === 'pin_only') {
  if (!withdrawForm.withdrawalPin) {
    alert('❌ Please enter your withdrawal PIN');
    return;
  }
  if (withdrawForm.withdrawalPin.length < 4) {
    alert('❌ Please enter a valid withdrawal PIN');
    return;
  }
}

  if (selectedWithdrawalMethod === 'crypto') {
    if (selectedWallet === 'binance' && !withdrawForm.binanceId) {
      alert('❌ Please enter your Binance ID');
      return;
    } else if (selectedWallet === 'trust_wallet' && !withdrawForm.cryptoWalletId) {
      alert('❌ Please enter your Trust Wallet ID');
      return;
    }
  }

  try {
    const formData = new FormData();
    
    // ✅ FIXED: Use correct user ID field
    const userId = user._id || user.id;
    console.log('✅ Using userId:', userId);
    
    formData.append('userId', userId);
    formData.append('tradeAccount', withdrawForm.tradeAccount);
    formData.append('amount', withdrawalAmount);
    formData.append('withdrawalType', withdrawalMode);
    formData.append('withdrawalMethod', selectedWithdrawalMethod);
    
    if (selectedWithdrawalMethod === 'crypto') {
      formData.append('cryptoCountry', selectedCryptoCountry || 'global');
      formData.append('cryptoWallet', selectedWallet);
      if (selectedWallet === 'binance') {
        formData.append('binanceId', withdrawForm.binanceId);
      } else if (selectedWallet === 'trust_wallet') {
        formData.append('cryptoWalletId', withdrawForm.cryptoWalletId);
      }
    }
    
    if (withdrawalMode === 'repeat_id_verification') {
      formData.append('withdrawalPin', withdrawForm.withdrawalPin);
      if (withdrawForm.identityProof) {
        formData.append('identityProof', withdrawForm.identityProof);
      }
    } else if (withdrawalMode === 'pin_only') {
      formData.append('withdrawalPin', withdrawForm.withdrawalPin);
    }

    console.log('📤 Sending withdrawal request to:', `${API_BASE_URL}/api/transactions/submit-withdrawal`);
    
    // ✅ Log FormData contents
    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`  ${key}: [File] ${value.name}`);
      } else {
        console.log(`  ${key}: ${value}`);
      }
    }

    const response = await fetch(`${API_BASE_URL}/api/transactions/submit-withdrawal`, {
      method: 'POST',
      body: formData
    });

    console.log('📡 Response status:', response.status);
    
    const responseData = await response.json();
    console.log('📥 Response data:', responseData);

    if (response.ok) {
      alert('✅ Withdrawal request submitted successfully! Admin will review your request.');
      
      setWithdrawForm({
        tradeAccount: '',
        amount: '',
        fullName: '',
        whatsappNumber: '',
        gender: '',
        identityProof: null,
        proofOfResidence: null,
        tradingExperience: '',
        tradingExperienceDetails: '',
        withdrawalPin: '',
        cryptoWalletId: '',
        binanceId: ''
      });

      setWithdrawalStep('method');
      setSelectedWithdrawalMethod('');
      setSelectedCryptoCountry('');
      setSelectedWallet('');

      await fetchTransactionHistory();
    } else {
      console.error('❌ Withdrawal failed:', responseData);
      alert(`❌ Failed to submit withdrawal: ${responseData.message || 'Unknown error'}`);
    }
  } catch (error) {
    console.error('❌ Error submitting withdrawal:', error);
    alert('❌ Network error. Please try again.');
  }
};

  // Handle change password submission
  const handleChangePasswordSubmit = async (e) => {
    e.preventDefault();
    
    const { currentPassword, newPassword, confirmPassword } = changePasswordForm;
    
    if (!currentPassword || !newPassword || !confirmPassword) {
      alert('❌ Please fill in all password fields');
      return;
    }
    
    if (newPassword !== confirmPassword) {
      alert('❌ New password and confirm password do not match');
      return;
    }
    
    if (newPassword.length < 6) {
      alert('❌ New password must be at least 6 characters long');
      return;
    }
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: user.id,
          currentPassword,
          newPassword
        })
      });
      
      if (response.ok) {
        alert('✅ Password changed successfully!');
        setChangePasswordForm({
          currentPassword: '',
          newPassword: '',
          confirmPassword: ''
        });
      } else {
        const error = await response.json();
        alert(`❌ Failed to change password: ${error.message}`);
      }
    } catch (error) {
      console.error('❌ Error changing password:', error);
      alert('❌ Network error. Please try again.');
    }
  };

  // Fetch referral data
  useEffect(() => {
    const fetchReferralData = async () => {
      if (!user?.id) return;
      
      try {
        const response = await fetch(`${API_BASE_URL}/api/admin/public/user-referrals/${user.id}`);
        if (response.ok) {
          const data = await response.json();
          if (data.success) {
            setReferralData(data.data);
            console.log('👥 Referral data loaded:', data.data);
          }
        } else {
          setReferralData({
            level: 1,
            totalReferrals: 0,
            commission: 0,
            referrals: []
          });
        }
      } catch (error) {
        console.error('❌ Error fetching referral data:', error);
        setReferralData({
          level: 1,
          totalReferrals: 0,
          commission: 0,
          referrals: []
        });
      }
    };

    fetchReferralData();
  }, [user]);

  // ✅ NEW: Start real-time balance synchronization
useEffect(() => {
  if (!user?.id) return;
  
  // Initial sync
  syncRealTimeBalances();
  
  // Set up 5-second interval for balance sync
  const interval = setInterval(syncRealTimeBalances, 5000);
  setBalanceRefreshInterval(interval);
  
  return () => {
    if (interval) {
      clearInterval(interval);
      setBalanceRefreshInterval(null);
    }
  };
}, [user?.id]);

  // Handle opening trading account modal
  const handleOpenRequestModal = () => {
    if (!user?.id) {
      alert('❌ User session not found. Please refresh and login again.');
      return;
    }
    
    console.log('🚀 Opening trading account modal for user:', user);
    setIsRequestModalOpen(true);
  };

  const handleCloseRequestModal = () => {
    setIsRequestModalOpen(false);
  };

  // Handle successful request submission
  const handleRequestSubmitted = async () => {
    try {
      console.log('✅ Account created, refreshing user data...');
      
      if (user?.id) {
        const [accountsResponse, requestsResponse] = await Promise.all([
          fetch(`${API_BASE_URL}/api/admin/public/user-trading-accounts/${user.id}`),
fetch(`${API_BASE_URL}/api/admin/public/user-account-requests/${user.id}`)
        ]);
        
        const accountsData = await accountsResponse.json();
        const requestsData = await requestsResponse.json();
        
        if (Array.isArray(accountsData)) {
          setTradeAccounts(accountsData);
          
          const totalBalance = accountsData
            .filter(account => account.adminStatus === 'approved')
            .reduce((sum, account) => sum + (parseFloat(account.balance) || 0), 0);
          
          setUserBalance(totalBalance);
          console.log('🔄 User balance recalculated:', totalBalance);
        }
        
        if (Array.isArray(requestsData)) {
          setAccountRequests(requestsData);
        }
      }
    } catch (error) {
      console.error('❌ Error refreshing user account data:', error);
    }
    
    setIsRequestModalOpen(false);
  };

  // Handle logout
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Handle navigation
  const handleNavItemClick = (idx) => {
    if (idx === navItems.length - 1) { // Logout index
      handleLogout();
      return;
    }
    setActiveNavIndex(idx);
  };

  const demoAccounts = [];
  const approvedAccounts = tradeAccounts.filter(acc => acc.adminStatus === 'approved');

// ✅ FIXED: Safe calculations with fallbacks
const safeDeposits = Array.isArray(deposits) ? deposits : [];
const safeWithdrawals = Array.isArray(withdrawals) ? withdrawals : [];

const depositStats = {
  submitted: safeDeposits.filter(d => d && d.status === 'submitted').reduce((sum, d) => sum + parseFloat(d.amount || 0), 0),
  pending: safeDeposits.filter(d => d && d.status === 'pending').reduce((sum, d) => sum + parseFloat(d.amount || 0), 0),
  approved: safeDeposits.filter(d => d && d.status === 'approved').reduce((sum, d) => sum + parseFloat(d.amount || 0), 0),
  rejected: safeDeposits.filter(d => d && d.status === 'rejected').reduce((sum, d) => sum + parseFloat(d.amount || 0), 0)
};

const withdrawalStats = {
  submitted: safeWithdrawals.filter(w => w && w.status === 'submitted').reduce((sum, w) => sum + parseFloat(w.amount || 0), 0),
  pending: safeWithdrawals.filter(w => w && w.status === 'pending').reduce((sum, w) => sum + parseFloat(w.amount || 0), 0),
  approved: safeWithdrawals.filter(w => w && w.status === 'approved').reduce((sum, w) => sum + parseFloat(w.amount || 0), 0),
  rejected: safeWithdrawals.filter(w => w && w.status === 'rejected').reduce((sum, w) => sum + parseFloat(w.amount || 0), 0)
};

// ✅ FIXED: Safe totals calculation
const totalDepositsAmount = depositStats.approved || 0; 
const totalWithdrawalsAmount = withdrawalStats.approved || 0;

console.log('✅ Safe calculations:', {
  totalDepositsAmount,
  totalWithdrawalsAmount,
  depositStats,
  withdrawalStats
});
// ✅ NEW: Use real-time balance data for dashboard
const totalAccountBalance = realTimeBalance.totalBalance || tradeAccounts
  .filter(acc => acc.adminStatus === 'approved')
  .reduce((sum, acc) => sum + parseFloat(acc.balance || 0), 0);

const totalAccountEquity = realTimeBalance.totalEquity || tradeAccounts
  .filter(acc => acc.adminStatus === 'approved')
  .reduce((sum, acc) => sum + parseFloat(acc.equity || acc.balance || 0), 0);

const totalAccountFreeMargin = realTimeBalance.totalFreeMargin || tradeAccounts
  .filter(acc => acc.adminStatus === 'approved')
  .reduce((sum, acc) => sum + parseFloat(acc.freeMargin || acc.equity || acc.balance || 0), 0);
// ✅ FIXED: Total Trading Account Balance = Only Account Balance
const totalCredit = tradeAccounts
  .filter(acc => acc.adminStatus === 'approved')
  .reduce((sum, acc) => sum + parseFloat(acc.credit || 0), 0);

const totalTradingAccountBalance = totalAccountBalance + totalCredit;


  // KYC notification component
  const renderKycNotification = () => {
    if (!userKycStatus) return null;
    
    if (!userKycStatus.hasKyc) {
      return (
        <div className={styles.kycNotification} style={{
          background: '#fef3c7', border: '1px solid #f59e0b', borderRadius: '8px',
          padding: '12px', marginBottom: '16px', fontSize: '14px'
        }}>
          <span style={{ color: '#92400e', fontWeight: 'bold' }}>
            📋 KYC Submission Required: Complete your verification for withdrawals
          </span>
        </div>
      );
    } else if (userKycStatus.isRejected) {
      return (
        <div style={{
          background: '#fee2e2', border: '1px solid #ef4444', borderRadius: '8px',
          padding: '12px', marginBottom: '16px', fontSize: '14px'
        }}>
          <span style={{ color: '#991b1b', fontWeight: 'bold' }}>
            ❌ KYC Rejected: {userKycStatus.rejectionReason || 'Please resubmit your documents.'}
          </span>
          <button onClick={() => setShowKycForm(true)} style={{
            marginLeft: '12px', background: '#ef4444', color: 'white',
            border: 'none', borderRadius: '4px', padding: '4px 10px', cursor: 'pointer'
          }}>
            Resubmit KYC
          </button>
        </div>
      );
    } else if (!userKycStatus.isApproved) {
      return (
        <div style={{
          background: '#dbeafe', border: '1px solid #3b82f6', borderRadius: '8px',
          padding: '12px', marginBottom: '16px', fontSize: '14px'
        }}>
          <span style={{ color: '#1e40af', fontWeight: 'bold' }}>
            ⏳ KYC Under Review: Your verification is being processed by admin
          </span>
        </div>
      );
    }
    return null;
  };

  // Return early if no user
  if (!user) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading user session...
      </div>
    );
  }



// ✅ FIXED: Add KYC submit handler (around line 400, after other handlers)
const handleKycSubmit = async (e) => {
  e.preventDefault();
  
  console.log('🚀 KYC submit started');
  console.log('📝 KYC form data:', kycForm);
  
  if (!kycForm.fullName || !kycForm.whatsappNumber || !kycForm.gender || 
      !kycForm.tradingExperience || !kycForm.identityProof || !kycForm.proofOfResidence) {
    alert('❌ Please fill in all required fields');
    return;
  }

  try {
    const formData = new FormData();
    formData.append('userId', user.id);
    formData.append('fullName', kycForm.fullName);
    formData.append('whatsappNumber', kycForm.whatsappNumber);
    formData.append('gender', kycForm.gender);
    formData.append('tradingExperience', kycForm.tradingExperience);
    formData.append('tradingExperienceDetails', kycForm.tradingExperienceDetails || '');
    
    if (kycForm.identityProof) {
      formData.append('identityProof', kycForm.identityProof);
    }
    if (kycForm.proofOfResidence) {
      formData.append('proofOfResidence', kycForm.proofOfResidence);
    }

    console.log('📤 Sending KYC data to API...');
    
    const response = await fetch(`${API_BASE_URL}/api/transactions/submit-kyc`, {
      method: 'POST',
      body: formData
    });

    if (response.ok) {
      alert('✅ KYC submitted successfully! Admin will review your documents.');
      
      // Reset form
      setKycForm({
        fullName: '',
        whatsappNumber: '',
        gender: '',
        identityProof: null,
        proofOfResidence: null,
        tradingExperience: '',
        tradingExperienceDetails: ''
      });
      
      setShowKycForm(false);
      
      // Refresh KYC status
      const kycResponse = await fetch(`${API_BASE_URL}/api/transactions/check-kyc-status/${user.id}`);
      const kycData = await kycResponse.json();
      setUserKycStatus(kycData);
      
    } else {
      const error = await response.json();
      alert(`❌ Failed to submit KYC: ${error.message}`);
    }
  } catch (error) {
    console.error('❌ Error submitting KYC:', error);
    alert('❌ Network error. Please try again.');
  }
};

// ✅ FIXED: Replace the entire KycForm component (around line 600)
const KycForm = () => (
  <div className={styles.kycFormModal}>
    <div className={styles.kycFormContainer}>
      <h2>KYC Submission</h2>
      <form className={styles.kycForm} onSubmit={handleKycSubmit}>
        
        <div className={styles.kycFormGroup}>
          <label>Full Name*</label>
          <input 
            type="text" 
            value={kycForm.fullName}
            onChange={(e) => setKycForm({...kycForm, fullName: e.target.value})}
            required 
          />
        </div>
        
        <div className={styles.kycFormGroup}>
          <label>Whatsapp Contact Number (please add country code)*</label>
          <input 
            type="text" 
            value={kycForm.whatsappNumber}
            onChange={(e) => setKycForm({...kycForm, whatsappNumber: e.target.value})}
            placeholder="+1234567890"
            required 
          />
        </div>
        
        <div className={styles.kycFormGroup}>
          <label>Gender*</label>
          <select 
            value={kycForm.gender}
            onChange={(e) => setKycForm({...kycForm, gender: e.target.value})}
            required
          >
            <option value="">Select One</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>
        
        <div className={styles.kycFormGroup}>
          <label>
            IDENTITY PROOF (National ID / DRIVING LICENSE)* <br />
            <small>Supported mimetypes: jpg, jpeg, png, pdf</small>
          </label>
          <input 
            type="file" 
            accept=".jpg,.jpeg,.png,.pdf" 
            onChange={(e) => setKycForm({...kycForm, identityProof: e.target.files[0]})}
            required 
          />
          {kycForm.identityProof && (
            <small style={{ color: '#10b981' }}>✅ {kycForm.identityProof.name}</small>
          )}
        </div>
        
        <div className={styles.kycFormGroup}>
          <label>
            Proof of Residence (PASSPORT / BANK PASSBOOK / Utility Bills)* <br />
            <small>Supported mimetypes: jpg, jpeg, png, pdf, doc, docx, txt, csv</small>
          </label>
          <input 
            type="file" 
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.txt,.csv" 
            onChange={(e) => setKycForm({...kycForm, proofOfResidence: e.target.files[0]})}
            required 
          />
          {kycForm.proofOfResidence && (
            <small style={{ color: '#10b981' }}>✅ {kycForm.proofOfResidence.name}</small>
          )}
        </div>
        
        <div className={styles.kycFormGroup}>
          <label>Trading experience*</label>
          <select 
            value={kycForm.tradingExperience}
            onChange={(e) => setKycForm({...kycForm, tradingExperience: e.target.value})}
            required
          >
            <option value="">Select One</option>
            <option value="beginner">Beginner</option>
            <option value="intermediate">Intermediate</option>
            <option value="expert">Expert</option>
          </select>
        </div>
        
        <div className={styles.kycFormGroup}>
          <label>What's Your Trading Experience? <span>(Optional)</span></label>
          <input 
            type="text" 
            value={kycForm.tradingExperienceDetails}
            onChange={(e) => setKycForm({...kycForm, tradingExperienceDetails: e.target.value})}
            placeholder="Describe your trading background..."
          />
        </div>
        
        <div>
          <button className={styles.kycFormSubmitBtn} type="submit">
            Submit KYC
          </button>
          <button 
            type="button" 
            className={styles.kycFormCancelBtn} 
            onClick={() => {
              setShowKycForm(false);
              setKycForm({
                fullName: '',
                whatsappNumber: '',
                gender: '',
                identityProof: null,
                proofOfResidence: null,
                tradingExperience: '',
                tradingExperienceDetails: ''
              });
            }}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
);


  return (
    <div className={`${styles.dashboardContainer} ${darkMode ? styles.dark : ""}`}>
      
      {showKycForm && (
  <div className={styles.kycFormModal}>
    <div className={styles.kycFormContainer}>
      <h2>KYC Submission</h2>
      <form className={styles.kycForm} onSubmit={handleKycSubmit}>
        <div className={styles.kycFormGroup}>
          <label>Full Name*</label>
          <input type="text" value={kycForm.fullName}
            onChange={(e) => setKycForm({...kycForm, fullName: e.target.value})} required />
        </div>
        <div className={styles.kycFormGroup}>
          <label>Whatsapp Contact Number (please add country code)*</label>
          <input type="text" value={kycForm.whatsappNumber}
            onChange={(e) => setKycForm({...kycForm, whatsappNumber: e.target.value})}
            placeholder="+1234567890" required />
        </div>
        <div className={styles.kycFormGroup}>
          <label>Gender*</label>
          <select value={kycForm.gender}
            onChange={(e) => setKycForm({...kycForm, gender: e.target.value})} required>
            <option value="">Select One</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div className={styles.kycFormGroup}>
          <label>IDENTITY PROOF (National ID / DRIVING LICENSE)*<br/>
            <small>Supported: jpg, jpeg, png, pdf</small></label>
          <input type="file" accept=".jpg,.jpeg,.png,.pdf"
            onChange={(e) => setKycForm({...kycForm, identityProof: e.target.files[0]})} required />
          {kycForm.identityProof && <small style={{color:'#10b981'}}>✅ {kycForm.identityProof.name}</small>}
        </div>
        <div className={styles.kycFormGroup}>
          <label>Proof of Residence (PASSPORT / BANK PASSBOOK / Utility Bills)*<br/>
            <small>Supported: jpg, jpeg, png, pdf, doc, docx, txt, csv</small></label>
          <input type="file" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.txt,.csv"
            onChange={(e) => setKycForm({...kycForm, proofOfResidence: e.target.files[0]})} required />
          {kycForm.proofOfResidence && <small style={{color:'#10b981'}}>✅ {kycForm.proofOfResidence.name}</small>}
        </div>
        <div className={styles.kycFormGroup}>
          <label>Trading experience*</label>
          <select value={kycForm.tradingExperience}
            onChange={(e) => setKycForm({...kycForm, tradingExperience: e.target.value})} required>
            <option value="">Select One</option>
            <option value="beginner">Beginner</option>
            <option value="intermediate">Intermediate</option>
            <option value="expert">Expert</option>
          </select>
        </div>
        <div className={styles.kycFormGroup}>
          <label>What's Your Trading Experience? <span>(Optional)</span></label>
          <input type="text" value={kycForm.tradingExperienceDetails}
            onChange={(e) => setKycForm({...kycForm, tradingExperienceDetails: e.target.value})}
            placeholder="Describe your trading background..." />
        </div>
        <div>
          <button className={styles.kycFormSubmitBtn} type="submit">Submit KYC</button>
          <button type="button" className={styles.kycFormCancelBtn}
            onClick={() => { setShowKycForm(false); setKycForm({fullName:'',whatsappNumber:'',gender:'',identityProof:null,proofOfResidence:null,tradingExperience:'',tradingExperienceDetails:''}); }}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
)}

      <TradingAccountModal
        isOpen={isRequestModalOpen}
        onClose={handleCloseRequestModal}
        onRequestSubmitted={handleRequestSubmitted}
        userId={user?.id}
        userName={user?.name}
        userBalance={userBalance}
      />

      <aside className={styles.sidebar}>
        <div className={styles.accountBalance}>
          <h3>ACCOUNT BALANCE</h3>
          <p className={styles.balanceAmount}>
  ${userBalance.toFixed(2)} USD
  <small style={{ 
    display: 'block', 
    fontSize: '11px', 
    color: '#10b981', 
    fontWeight: 'normal',
    marginTop: '4px'
  }}>
    ✅ Total Trading Balance (Live)
  </small>
</p>

          <div className={styles.balanceButtons}>
            <button 
              className={styles.depositButton}
              onClick={() => setActiveNavIndex(DEPOSIT_INDEX)}
            >
              Deposit
            </button>
            <button 
              className={styles.withdrawButton}
              onClick={() => setActiveNavIndex(WITHDRAW_INDEX)}
            >
              Withdraw
            </button>
          </div>
        </div>
        <ul className={styles.navigation}>
          {navItems.map((item, idx) => (
            <li
              key={item.label}
              className={`${styles.navigationItem} ${idx === activeNavIndex ? styles.active : ""}`}
              onClick={() => handleNavItemClick(idx)}
            >
              <span className={styles.icon}>
                {item.icon && <FontAwesomeIcon icon={item.icon} />}
              </span>
              {item.label}
            </li>
          ))}
        </ul>
      </aside>

      <main className={styles.main}>
        {/* ✅ DEPOSIT SECTION */}
        {activeNavIndex === DEPOSIT_INDEX && (
          <div className={styles.depositSection}>
            <div className={styles.depositHeader}>
              <h2 className={styles.sectionTitle}>Deposit Funds</h2>
              <button 
                className={styles.historyBtn}
                onClick={() => setActiveNavIndex(TRANSACTIONS_INDEX)}
              >
                Deposit History
              </button>
            </div>

            <div className={styles.formContainer}>
              <form onSubmit={handleDepositSubmit} className={styles.depositForm}>
                
                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>
                    Select Gateway <span className={styles.required}>*</span>
                  </label>
                  <select 
                    className={styles.formSelect}
                    value={depositForm.gateway}
                    onChange={(e) => {
  setDepositForm({...depositForm, gateway: e.target.value});
}}
                    required
                  >
                    <option value="">Select One</option>
                    <option value="indian_upi">Indian UPI</option>
                   
<option value="bank_transfer">Bank Transfer</option>
                    <option value="crypto_usdt">Crypto USDT</option>
                  </select>
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>
                    Trade Account <span className={styles.required}>*</span>
                  </label>
                  <select 
                    className={styles.formSelect}
                    value={depositForm.tradeAccount}
                    onChange={(e) => setDepositForm({...depositForm, tradeAccount: e.target.value})}
                    required
                  >
                    <option value="">Select Account</option>
                    {approvedAccounts.map(account => (
                      <option key={account.accountId} value={account.accountId}>
                        {account.accountId}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>
                    Amount <span className={styles.required}>*</span>
                  </label>
                  <div className={styles.amountInputWrapper}>
                    <input 
                      type="number"
                      className={styles.formInput}
                      placeholder=""
                      value={depositForm.amount}
                      onChange={(e) => setDepositForm({...depositForm, amount: e.target.value})}
                      min="10"
                      step="0.01"
                      required
                    />
                    <span className={styles.currencyLabel}>USD</span>
                  </div>
                </div>

                <button 
                  type="submit" 
                  className={styles.submitBtn}
                  disabled={approvedAccounts.length === 0}
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        )}

        {/* ✅ WITHDRAW SECTION */}
        {activeNavIndex === WITHDRAW_INDEX && (
          <div className={styles.withdrawSection}>
            <div className={styles.withdrawHeader}>
              <h2 className={styles.sectionTitle}>Withdrawal Request</h2>
              <button 
                className={styles.historyBtn}
                onClick={() => setActiveNavIndex(TRANSACTIONS_INDEX)}
              >
                Withdrawal History
              </button>
            </div>

            {renderKycNotification()}

            {/* ✅ BLOCK: No KYC submitted yet */}
            {!userKycStatus?.hasKyc ? (
              <div style={{
                background: '#fef3c7', border: '2px solid #f59e0b', borderRadius: '12px',
                padding: '32px', textAlign: 'center', marginTop: '20px'
              }}>
                <div style={{ fontSize: '48px', marginBottom: '12px' }}>🔒</div>
                <h3 style={{ color: '#92400e', marginBottom: '8px' }}>Withdrawal Unavailable</h3>
                <p style={{ color: '#78350f', marginBottom: '20px', fontSize: '15px' }}>
                  You must complete KYC verification before making any withdrawal requests.
                  <br />Minimum withdrawal amount is <strong>$10 USD</strong>.
                </p>
                <button
                  onClick={() => setShowKycForm(true)}
                  style={{
                    background: '#f59e0b', color: 'white', border: 'none',
                    borderRadius: '8px', padding: '12px 28px', fontSize: '15px',
                    fontWeight: 'bold', cursor: 'pointer'
                  }}
                >
                  📋 Submit KYC to Enable Withdrawals
                </button>
              </div>
            ) : userKycStatus?.isRejected ? (
              <div style={{
                background: '#fee2e2', border: '2px solid #ef4444', borderRadius: '12px',
                padding: '32px', textAlign: 'center', marginTop: '20px'
              }}>
                <div style={{ fontSize: '48px', marginBottom: '12px' }}>❌</div>
                <h3 style={{ color: '#991b1b', marginBottom: '8px' }}>KYC Rejected</h3>
                <p style={{ color: '#7f1d1d', marginBottom: '20px', fontSize: '15px' }}>
                  {userKycStatus.rejectionReason || 'Your KYC was rejected by admin.'}
                  <br />Please resubmit your documents to enable withdrawals.
                </p>
                <button
                  onClick={() => setShowKycForm(true)}
                  style={{
                    background: '#ef4444', color: 'white', border: 'none',
                    borderRadius: '8px', padding: '12px 28px', fontSize: '15px',
                    fontWeight: 'bold', cursor: 'pointer'
                  }}
                >
                  🔄 Resubmit KYC
                </button>
              </div>
            ) : userKycStatus?.hasKyc && !userKycStatus?.isApproved ? (
              <div style={{
                background: '#dbeafe', border: '2px solid #3b82f6', borderRadius: '12px',
                padding: '32px', textAlign: 'center', marginTop: '20px'
              }}>
                <div style={{ fontSize: '48px', marginBottom: '12px' }}>⏳</div>
                <h3 style={{ color: '#1e40af', marginBottom: '8px' }}>KYC Under Review</h3>
                <p style={{ color: '#1e3a8a', fontSize: '15px' }}>
                  Your KYC is being reviewed by admin. Withdrawals will be available once approved.
                  <br />Minimum withdrawal amount is <strong>$10 USD</strong>.
                </p>
              </div>
            ) : (
              <>

            {withdrawalStep === 'method' && (
              <div className={styles.withdrawalMethodSelection}>
                <h3 style={{ marginBottom: '20px' }}>Choose Withdrawal Method:</h3>
                <div className={styles.methodButtons}>
                  <button
                    onClick={() => {
                      setSelectedWithdrawalMethod('bank');
                      setWithdrawalStep('bank_selection');
                    }}
                    className={styles.methodButton}
                  >
                    <span style={{ fontSize: '24px' }}>🏦</span>
                    <span>Bank Transfer</span>
                  </button>
                  <button
                    onClick={() => {
                      setSelectedWithdrawalMethod('crypto');
                      setWithdrawalStep('wallet_selection');
                    }}
                    className={styles.methodButton}
                  >
                    <span style={{ fontSize: '24px' }}>₿</span>
                    <span>Crypto</span>
                  </button>
                </div>
              </div>
            )}

            {withdrawalStep === 'bank_selection' && (
              <div className={styles.bankSelection}>
                <div className={styles.stepHeader}>
                  <button onClick={() => setWithdrawalStep('method')} className={styles.backBtn}>← Back</button>
                  <h3>Select Bank Location:</h3>
                </div>
                <div className={styles.bankButtons}>
                  <button
                    onClick={() => {
                      alert('🏦 Bank withdrawals are coming soon!\n\nWe are currently setting up partnerships with banks in USA, UAE, and England. \n\nFor now, please use crypto withdrawals. Thank you for your patience! 🙏');
                    }}
                    className={styles.bankButton}
                    style={{ opacity: 0.6 }}
                  >
                    🇺🇸 USA Bank
                    <div style={{ fontSize: '12px', color: '#6b7280' }}>Coming Soon</div>
                  </button>
                  <button
                    onClick={() => {
                      alert('🏦 Bank withdrawals are coming soon!\n\nWe are currently setting up partnerships with banks in USA, UAE, and England. \n\nFor now, please use crypto withdrawals. Thank you for your patience! 🙏');
                    }}
                    className={styles.bankButton}
                    style={{ opacity: 0.6 }}
                  >
                    🇦🇪 UAE Bank
                    <div style={{ fontSize: '12px', color: '#6b7280' }}>Coming Soon</div>
                  </button>
                  <button
                    onClick={() => {
                      alert('🏦 Bank withdrawals are coming soon!\n\nWe are currently setting up partnerships with banks in USA, UAE, and England. \n\nFor now, please use crypto withdrawals. Thank you for your patience! 🙏');
                    }}
                    className={styles.bankButton}
                    style={{ opacity: 0.6 }}
                  >
                    🏴󠁧󠁢󠁥󠁮󠁧󠁿 Bank of England
                    <div style={{ fontSize: '12px', color: '#6b7280' }}>Coming Soon</div>
                  </button>
                </div>
              </div>
            )}

            {withdrawalStep === 'wallet_selection' && (
              <div className={styles.walletSelection}>
                <div className={styles.stepHeader}>
                  <button onClick={() => setWithdrawalStep('method')} className={styles.backBtn}>← Back</button>
                  <h3>Choose Your Crypto Wallet:</h3>
                </div>
                <div className={styles.walletButtons}>
                  <button
                    onClick={() => {
                      setSelectedWallet('binance');
                      setWithdrawalStep('form');
                    }}
                    className={styles.walletButton}
                  >
                    <span style={{ fontSize: '32px', color: '#f0b90b' }}>🟡</span>
                    <span style={{ fontWeight: 'bold' }}>Binance</span>
                    <small style={{ fontSize: '12px', color: '#6b7280' }}>Global Exchange</small>
                  </button>
                  <button
                    onClick={() => {
                      setSelectedWallet('trust_wallet');
                      setWithdrawalStep('form');
                    }}
                    className={styles.walletButton}
                  >
                    <span style={{ fontSize: '32px', color: '#3375bb' }}>🔵</span>
                    <span style={{ fontWeight: 'bold' }}>Trust Wallet</span>
                    <small style={{ fontSize: '12px', color: '#6b7280' }}>Mobile Wallet</small>
                  </button>
                </div>
              </div>
            )}

            {withdrawalStep === 'form' && (
              <>
                {userKycStatus?.isApproved && (
                  <div className={styles.withdrawalModeSelection} style={{ marginBottom: '20px' }}>
                    <h3 style={{ marginBottom: '12px' }}>Choose Verification Method:</h3>
                    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                      <button
                        onClick={() => setWithdrawalMode('repeat_id_verification')}
                        style={{
                          padding: '10px 16px',
                          border: '2px solid',
                          borderColor: withdrawalMode === 'repeat_id_verification' ? '#3b82f6' : '#d1d5db',
                          background: withdrawalMode === 'repeat_id_verification' ? '#eff6ff' : 'white',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '14px'
                        }}
                      >
                        📄 Upload ID + PIN
                      </button>
                      <button
                        onClick={() => setWithdrawalMode('pin_only')}
                        style={{
                          padding: '10px 16px',
                          border: '2px solid',
                          borderColor: withdrawalMode === 'pin_only' ? '#3b82f6' : '#d1d5db',
                          background: withdrawalMode === 'pin_only' ? '#eff6ff' : 'white',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '14px'
                        }}
                      >
                        🔢 Use PIN Only
                      </button>
                    </div>
                  </div>
                )}

                <div className={styles.formContainer}>
                  <div className={styles.stepHeader}>
                    <button 
                      onClick={() => {
                        if (selectedWithdrawalMethod === 'crypto') {
                          setWithdrawalStep('wallet_selection');
                        } else if (selectedWithdrawalMethod === 'bank') {
                          setWithdrawalStep('bank_selection');
                        }
                      }} 
                      className={styles.backBtn}
                    >
                      ← Back
                    </button>
                    <h3>Complete Withdrawal Details:</h3>
                  </div>

                  <div className={styles.selectedMethodInfo} style={{
                    background: '#f0f9ff', border: '1px solid #0ea5e9', borderRadius: '6px',
                    padding: '12px', marginBottom: '20px', fontSize: '14px'
                  }}>
                    <strong>Selected:</strong> 
                    {selectedWithdrawalMethod === 'crypto' && 
                      ` Crypto Withdrawal → ${selectedWallet === 'binance' ? 'Binance 🟡' : 'Trust Wallet 🔵'}`
                    }
                    {selectedWithdrawalMethod === 'bank' && 
                      ` Bank Transfer (${selectedCryptoCountry.toUpperCase()})`
                    }
                  </div>

                  <form onSubmit={handleWithdrawSubmit} className={styles.withdrawForm}>
                    
                    <div className={styles.formGroup}>
                      <label className={styles.formLabel}>
                        Trade Account <span className={styles.required}>*</span>
                      </label>
                      <select 
                        className={styles.formSelect}
                        value={withdrawForm.tradeAccount}
                        onChange={(e) => setWithdrawForm({...withdrawForm, tradeAccount: e.target.value})}
                        required
                      >
                        <option value="">Select One</option>
                        {approvedAccounts.filter(acc => parseFloat(acc.balance) > 0).map(account => (
  <option key={account.accountId} value={account.accountId}>
    {account.accountId} - Balance: ${parseFloat(account.balance).toLocaleString()}
  </option>

                        ))}
                      </select>
                    </div>

                    <div className={styles.formGroup}>
                      <label className={styles.formLabel}>
                        Amount <span className={styles.required}>*</span>
                      </label>
                      <div className={styles.amountInputWrapper}>
                       <input
  type="number"
  className={styles.formInput}
  placeholder=""
  value={withdrawForm.amount}
  onChange={(e) => setWithdrawForm({...withdrawForm, amount: e.target.value})}
  min="0.01"
  step="0.01"
  required
/>
<span className={styles.currencyLabel}>USD</span>
                      </div>
                    </div>

                    {selectedWithdrawalMethod === 'crypto' && selectedWallet === 'binance' && (
                      <div className={styles.formGroup}>
                        <label className={styles.formLabel}>
                          Binance ID <span className={styles.required}>*</span>
                        </label>
                        <input 
                          type="text"
                          className={styles.formInput}
                          placeholder="Enter your Binance ID (max 30 characters)"
                          value={withdrawForm.binanceId}
                          onChange={(e) => setWithdrawForm({...withdrawForm, binanceId: e.target.value.slice(0, 30)})}
                          maxLength="30"
                          required
                        />
                        <small className={styles.helpText}>Maximum 30 characters allowed</small>
                      </div>
                    )}

                    {selectedWithdrawalMethod === 'crypto' && selectedWallet === 'trust_wallet' && (
                      <div className={styles.formGroup}>
                        <label className={styles.formLabel}>
                          Trust Wallet ID <span className={styles.required}>*</span>
                        </label>
                        <input 
                          type="text"
                          className={styles.formInput}
                          placeholder="Enter your Trust Wallet address (max 30 characters)"
                          value={withdrawForm.cryptoWalletId}
                          onChange={(e) => setWithdrawForm({...withdrawForm, cryptoWalletId: e.target.value.slice(0, 30)})}
                          maxLength="30"
                          required
                        />
                        <small className={styles.helpText}>Maximum 30 characters allowed</small>
                      </div>
                    )}

                    
                       

                    {/* Repeat ID Verification */}
                    {withdrawalMode === 'repeat_id_verification' && (
                      <>
                        <div className={styles.formGroup}>
                          <label className={styles.formLabel}>
                            Upload Identity Proof for Verification <span className={styles.required}>*</span>
                          </label>
                          <div className={styles.fileInputContainer}>
                            <input 
                              type="file"
                              className={styles.fileInput}
                              accept=".jpg,.jpeg,.png,.pdf"
                              onChange={(e) => setWithdrawForm({...withdrawForm, identityProof: e.target.files[0]})}
                              required
                            />
                            <div className={styles.fileInputLabel}>
                              {withdrawForm.identityProof ? withdrawForm.identityProof.name : "No file selected."}
                            </div>
                          </div>
                          <small className={styles.helpText}>
                            Upload your ID proof for admin verification against your stored KYC profile
                          </small>
                        </div>

                        <div className={styles.formGroup}>
                          <label className={styles.formLabel}>
                            Enter Withdrawal PIN <span className={styles.required}>*</span>
                          </label>
                          <input 
                            type="password"
                            className={styles.formInput}
                            placeholder="Enter your withdrawal PIN"
                            value={withdrawForm.withdrawalPin}
                            onChange={(e) => setWithdrawForm({...withdrawForm, withdrawalPin: e.target.value})}
                            minLength="4"
                            maxLength="6"
                            pattern="[0-9]{4,6}"
                            required
                          />
                        </div>
                      </>
                    )}

                    {/* PIN Only */}
                    {withdrawalMode === 'pin_only' && (
                      <div className={styles.formGroup}>
                        <label className={styles.formLabel}>
                          Enter Withdrawal PIN <span className={styles.required}>*</span>
                        </label>
                        <input 
                          type="password"
                          className={styles.formInput}
                          placeholder="Enter your withdrawal PIN"
                          value={withdrawForm.withdrawalPin}
                          onChange={(e) => setWithdrawForm({...withdrawForm, withdrawalPin: e.target.value})}
                          minLength="4"
                          maxLength="6"
                          pattern="[0-9]{4,6}"
                          required
                        />
                        <small className={styles.helpText}>
                          Enter the PIN you created during your first withdrawal
                        </small>
                      </div>
                    )}

                  <button
  type="submit"
  className={styles.submitBtn}
  disabled={!withdrawalMode || approvedAccounts.filter(acc => parseFloat(acc.balance) > 0).length === 0}
>
  Submit Withdrawal Request
</button>

                  </form>
                </div>
              </>
            )}
            </>
          )}
          </div>
        )}
        {/* ✅ CHANGE PASSWORD SECTION */}
        {activeNavIndex === CHANGE_PASSWORD_INDEX && (
          <div className={styles.changePasswordSection}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>Change Password</h2>
            </div>

            <div className={styles.formContainer}>
              <form onSubmit={handleChangePasswordSubmit} className={styles.changePasswordForm}>
                
                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>
                    Current Password <span className={styles.required}>*</span>
                  </label>
                  <input 
                    type="password"
                    className={styles.formInput}
                    placeholder="Enter your current password"
                    value={changePasswordForm.currentPassword}
                    onChange={(e) => setChangePasswordForm({...changePasswordForm, currentPassword: e.target.value})}
                    required
                  />
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>
                    New Password <span className={styles.required}>*</span>
                  </label>
                  <input 
                    type="password"
                    className={styles.formInput}
                    placeholder="Enter new password (min 6 characters)"
                    value={changePasswordForm.newPassword}
                    onChange={(e) => setChangePasswordForm({...changePasswordForm, newPassword: e.target.value})}
                    minLength="6"
                    required
                  />
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>
                    Confirm New Password <span className={styles.required}>*</span>
                  </label>
                  <input 
                    type="password"
                    className={styles.formInput}
                    placeholder="Confirm your new password"
                    value={changePasswordForm.confirmPassword}
                    onChange={(e) => setChangePasswordForm({...changePasswordForm, confirmPassword: e.target.value})}
                    required
                  />
                </div>

                <button type="submit" className={styles.submitBtn}>
                  Change Password
                </button>
              </form>
            </div>
          </div>
        )}

        {/* ✅ FIXED: MY REFERRALS SECTION */}
        {activeNavIndex === REFERRALS_INDEX && (
          <div className={styles.referralsSection}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>My Referrals</h2>
            </div>

            <div className={styles.referralStatsHorizontal} style={{
              display: 'flex',
              gap: '20px',
              marginBottom: '30px',
              alignItems: 'center'
            }}>
              <div className={styles.referralLevel} style={{
                background: '#f8fafc',
                padding: '20px',
                borderRadius: '8px',
                minWidth: '200px'
              }}>
                <h3 style={{ margin: '0 0 10px 0' }}>Level {referralData.level}</h3>
                <div className={styles.levelProgress} style={{
                  width: '100%',
                  height: '10px',
                  background: '#e5e7eb',
                  borderRadius: '5px',
                  marginBottom: '10px'
                }}>
                  <div 
                    className={styles.progressBar} 
                    style={{
                      width: `${Math.min((referralData.totalReferrals / 10) * 100, 100)}%`,
                      height: '100%',
                      background: '#22c55e',
                      borderRadius: '5px'
                    }}
                  ></div>
                </div>
                <p style={{ margin: 0, fontSize: '14px' }}>{referralData.totalReferrals}/10 referrals to next level</p>
              </div>
              
              <div className={styles.referralCardsHorizontal} style={{
                display: 'flex',
                gap: '15px',
                flex: 1
              }}>
                <div className={styles.referralCard} style={{
                  background: '#f0f9ff',
                  padding: '20px',
                  borderRadius: '8px',
                  textAlign: 'center',
                  flex: 1
                }}>
                  <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#6b7280' }}>Total Referrals</h4>
                  <p className={styles.referralNumber} style={{ 
                    margin: 0, 
                    fontSize: '24px', 
                    fontWeight: 'bold', 
                    color: '#1e40af' 
                  }}>
                    {referralData.totalReferrals}
                  </p>
                </div>
                <div className={styles.referralCard} style={{
                  background: '#f0fdf4',
                  padding: '20px',
                  borderRadius: '8px',
                  textAlign: 'center',
                  flex: 1
                }}>
                  <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#6b7280' }}>Total Commission</h4>
                  <p className={styles.referralNumber} style={{ 
                    margin: 0, 
                    fontSize: '24px', 
                    fontWeight: 'bold', 
                    color: '#166534' 
                  }}>
                    ${referralData.commission.toLocaleString()}
                  </p>
                </div>
                <div className={styles.referralCard} style={{
                  background: '#fef3c7',
                  padding: '20px',
                  borderRadius: '8px',
                  textAlign: 'center',
                  flex: 1
                }}>
                  <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#6b7280' }}>Current Level</h4>
                  <p className={styles.referralNumber} style={{ 
                    margin: 0, 
                    fontSize: '24px', 
                    fontWeight: 'bold', 
                    color: '#92400e' 
                  }}>
                    Level {referralData.level}
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.referralChart} style={{ marginBottom: '30px' }}>
              <h3 style={{ marginBottom: '15px' }}>Referral Performance</h3>
              <div className={styles.chartPlaceholder} style={{
                height: '200px', 
                background: '#f8f9fa', 
                border: '1px dashed #dee2e6', 
                borderRadius: '8px', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center'
              }}>
                📊 Chart: Referral growth over time
              </div>
            </div>

            <div className={styles.referralsTable}>
              <h3 style={{ marginBottom: '15px' }}>Your Referrals ({referralData.referrals.length})</h3>
              <div className={styles.tableWrapper}>
                <table className={styles.historyTable}>
                  <thead>
                    <tr>
                      <th>Client Name</th>
                      <th>Account Balance</th>
                      <th>Commission</th>
                      <th>Group</th>
                      <th>Level</th>
                    </tr>
                  </thead>
                  <tbody>
                    {referralData.referrals.length === 0 ? (
                      <tr>
                        <td colSpan={5} style={{ textAlign: "center", color: "#adb7bd", padding: "30px 0" }}>
                          No referrals found. Share your referral link to start earning!
                        </td>
                      </tr>
                    ) : (
                      referralData.referrals.map((referral, index) => (
                        <tr key={index}>
                          <td>{referral.clientName}</td>
                          <td>${parseFloat(referral.accountBalance || 0).toLocaleString()}</td>
                          <td>${parseFloat(referral.commission || 0).toLocaleString()}</td>
                          <td>{referral.group}</td>
                          <td>{referral.level || 1}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* ✅ FIXED: Referral Link with user instead of currentUser */}
            <div className={styles.referralLink} style={{ marginTop: '30px' }}>
              <h3 style={{ marginBottom: '15px' }}>Your Referral Link</h3>
              <div className={styles.linkContainer} style={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center'
              }}>
                <input 
                  type="text" 
                  value={`https://stoneforex.com/register?ref=${user?.id}`} 
                  readOnly 
                  className={styles.linkInput}
                  style={{
                    flex: 1,
                    padding: '10px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    background: '#f9fafb'
                  }}
                />
                <button 
                  onClick={() => {
                    navigator.clipboard.writeText(`https://stoneforex.com/register?ref=${user?.id}`);
                    alert('✅ Referral link copied to clipboard!');
                  }}
                  className={styles.copyBtn}
                  style={{
                    padding: '10px 20px',
                    background: '#3b82f6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  Copy Link
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ✅ TRANSACTIONS SECTION */}
        {activeNavIndex === TRANSACTIONS_INDEX && (
          <div className={styles.transactionsSection}>
            <div className={styles.transactionsHeader}>
              <h2 className={styles.sectionTitle}>Transaction History</h2>
            </div>

            <div className={styles.transactionTabs}>
              <div className={styles.tab}>
                <h3>Deposit History ({deposits.length})</h3>
                <div className={styles.transactionTable}>
                  {deposits.length === 0 ? (
                    <p className={styles.emptyMessage}>No deposit transactions found.</p>
                  ) : (
                    <table className={styles.historyTable}>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Account</th>
                          <th>Gateway</th>
                          <th>Amount</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {deposits.map((deposit, index) => (
                          <tr key={index}>
                            <td>{new Date(deposit.createdAt).toLocaleDateString()}</td>
                            <td>{deposit.tradeAccount}</td>
                            <td>{deposit.gateway}</td>
                            <td>${parseFloat(deposit.amount).toLocaleString()}</td>
                            <td>
                              <span className={`${styles.statusBadge} ${styles[deposit.status]}`}>
                                {deposit.status === 'submitted' && 'Submitted'}
                                {deposit.status === 'pending' && 'Pending'}
                                {deposit.status === 'approved' && 'Approved'}
                                {deposit.status === 'rejected' && 'Rejected'}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>

              <div className={styles.tab}>
                <h3>Withdrawal History ({withdrawals.length})</h3>
                <div className={styles.transactionTable}>
                  {withdrawals.length === 0 ? (
                    <p className={styles.emptyMessage}>No withdrawal transactions found.</p>
                  ) : (
                    <table className={styles.historyTable}>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Type</th>
                          <th>Method</th>
                          <th>Account</th>
                          <th>Amount</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {withdrawals.map((withdrawal, index) => (
                          <tr key={index}>
                            <td>{new Date(withdrawal.createdAt).toLocaleDateString()}</td>
                            <td>
                              {withdrawal.withdrawalType === 'first_time_kyc' && '🆕 First KYC'}
                              {withdrawal.withdrawalType === 'repeat_id_verification' && '🔄 ID Check'}
                              {withdrawal.withdrawalType === 'pin_only' && '🔢 PIN Only'}
                              {!withdrawal.withdrawalType && '📋 KYC Withdrawal'}
                            </td>
                            <td>
                              {withdrawal.withdrawalMethod === 'crypto' && `₿ ${withdrawal.cryptoWallet || 'Crypto'}`}
                              {withdrawal.withdrawalMethod === 'bank' && '🏦 Bank'}
                              {!withdrawal.withdrawalMethod && 'Standard'}
                            </td>
                            <td>{withdrawal.tradeAccount}</td>
                            <td>${parseFloat(withdrawal.amount).toLocaleString()}</td>
                            <td>
                              <span className={`${styles.statusBadge} ${styles[withdrawal.status]}`}>
                                {withdrawal.status === 'submitted' && 'Submitted'}
                                {withdrawal.status === 'pending' && 'Pending'}
                                {withdrawal.status === 'approved' && 'Approved'}
                                {withdrawal.status === 'rejected' && 'Rejected'}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ✅ FIXED: TRADING ACCOUNTS SECTION */}
        {activeNavIndex === TRADE_ACCOUNTS_INDEX && (
          <div className={styles.tradeAccountsSection}>
            <div className={styles.tradeHeader}>
              <h2 className={styles.sectionTitle}>Real Trade Accounts</h2>
              <button 
                className={styles.openAccountBtn}
                onClick={handleOpenRequestModal}
                disabled={!user?.id}
                title={!user?.id ? "Please login to create account" : "Create new trading account"}
              >
                Open New Real Account
              </button>
            </div>

            {accountRequests.length > 0 && (
              <div className={styles.requestsSection}>
                <h3>Your Account Requests</h3>
                <div className={styles.requestsList}>
                  {accountRequests.map(request => (
                    <div key={request._id} className={styles.requestItem}>
                      <div className={styles.requestInfo}>
                        <span className={styles.requestType}>
                          {request.accountType}
                          {request.accountType?.toLowerCase().includes('algo') && (
                            <span className={styles.algoIcon} title="Algo Trading Account">
                              <FontAwesomeIcon icon={faRobot} style={{marginLeft: '8px', color: '#10b981'}} />
                            </span>
                          )}
                        </span>
                        <span className={styles.requestLeverage}>Leverage: 1:{request.leverage}</span>
                        <span className={styles.requestExperience}>Experience: {request.tradingExperience}</span>
                      </div>
                      <div className={styles.requestStatus}>
                        <span className={`${styles.statusBadge} ${styles[request.status]}`}>
                          {request.status === 'pending' && '⏳ Pending Admin Review'}
                          {request.status === 'approved' && '✅ Approved'}
                          {request.status === 'rejected' && '❌ Rejected'}
                        </span>
                        <span className={styles.requestDate}>
                          {new Date(request.createdAt).toLocaleDateString()}
                        </span>
                      </div>
                      {request.adminNotes && (
                        <div className={styles.adminNotes}>
                          <strong>Admin Notes:</strong> {request.adminNotes}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className={styles.tableWrapper}>
              <table className={styles.tradeAccountsTable}>
                <thead>
                  <tr>
                    <th>Account</th>
                    <th>Type</th>
                    <th>Main Password</th>
                    <th>Investor Password</th>
                    <th>Group</th>
                    <th>Balance</th>
                    <th>Equity</th>
                    <th>Leverage</th>
                    <th>Live Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={10} style={{ textAlign: "center", color: "#adb7bd", padding: "30px 0" }}>
                        Loading trading accounts...
                      </td>
                    </tr>
                  ) : tradeAccounts.length === 0 ? (
                    <tr>
                      <td colSpan={10} style={{ textAlign: "center", color: "#adb7bd", padding: "30px 0" }}>
                        No trading accounts found. Create your first trading account above.
                      </td>
                    </tr>
                  ) : (
                    tradeAccounts.map((ta) => (
                      <tr key={ta.accountId}>
                        <td><strong>{ta.accountId}</strong></td>
                        <td>
                          <span className={styles.accountTypeContainer}>
                            Real
                            {ta.accountType?.toLowerCase().includes('algo') && ta.adminStatus === 'approved' && (
                              <span className={styles.algoIcon} title="Algo Trading Account">
                                <FontAwesomeIcon icon={faRobot} style={{marginLeft: '6px', color: '#10b981', fontSize: '14px'}} />
                              </span>
                            )}
                          </span>
                        </td>
                        <td>••••••••</td>
                        <td>••••••••</td>
                        <td>
                          <span className={styles.groupBadge}>
                            {ta.group}
                          </span>
                        </td>
                        <td>${parseFloat(ta.balance || 0).toLocaleString()}</td>
                        <td>${parseFloat(ta.equity || ta.balance || 0).toLocaleString()}</td>
                        <td>1:{ta.leverage}</td>
                        <td>
                          <div className={styles.statusContainer}>
                            {ta.adminStatus === 'approved' ? (
                              <input 
                                type="checkbox" 
                                checked={true} 
                                readOnly 
                                style={{ accentColor: "#22c55e" }} 
                                title="Account Approved & Live"
                              />
                            ) : ta.adminStatus === 'rejected' ? (
                              <span className={styles.rejectedStatus} title="Account Rejected">
                                ❌
                              </span>
                            ) : (
                              <span className={styles.pendingStatus} title="Pending Admin Approval">
                                ⏳
                              </span>
                            )}
                          </div>
                        </td>
                        <td>
                          <button 
                            className={styles.editAccountBtn} 
                            title="View Credentials" 
                            onClick={() => {
                              if (ta.adminStatus === 'approved') {
                                const algoText = ta.accountType?.toLowerCase().includes('algo') ? '\n🤖 Type: Algo Trading Account' : '';
                                alert(`🔐 Trading Account Details:\n\n📊 Account: ${ta.accountId}${algoText}\n🗝️ Main Password: ${ta.mainPassword}\n🔍 Investor Password: ${ta.investorPassword}\n🖥️ Server: ${ta.server}\n📈 Group: ${ta.group}\n💰 Balance: $${parseFloat(ta.balance || 0).toLocaleString()}\n⚖️ Leverage: 1:${ta.leverage}\n\n✅ Status: Account is Live & Active`);
                              } else if (ta.adminStatus === 'rejected') {
                                alert(`❌ Account ${ta.accountId} has been rejected by admin.\n\nPlease contact support for more information.`);
                              } else {
                                alert(`⏳ Account ${ta.accountId} is pending admin approval.\n\nCredentials will be available after approval.`);
                              }
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            👁️
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Demo Accounts Section */}
        {activeNavIndex === DEMO_ACCOUNTS_INDEX && (
          <div className={styles.demoAccountsSection}>
            <div className={styles.demoHeader}>
              <button className={styles.openDemoBtn}>Open Demo Account</button>
            </div>
            <div className={styles.tableWrapper}>
              <table className={styles.demoAccountsTable}>
                <thead>
                  <tr>
                    <th>Account</th>
                    <th>Main Password</th>
                    <th>Investor Password</th>
                    <th>Group</th>
                    <th>Balance</th>
                    <th>Equity</th>
                    <th>Leverage</th>
                    <th>Live Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {demoAccounts.length === 0 ? (
                    <tr>
                      <td colSpan={9} style={{ textAlign: "center", color: "#adb7bd", padding: "30px 0" }}>
                        No demo accounts found.
                      </td>
                    </tr>
                  ) : (
                    demoAccounts.map((account) => (
                      <tr key={account.account}>
                        <td>{account.account}</td>
                        <td>
  <span 
    title={ta.adminStatus === 'approved' && ta.mainPassword ? `Main Password: ${ta.mainPassword}` : 'Pending approval'}
    style={{
      cursor: ta.adminStatus === 'approved' && ta.mainPassword ? 'help' : 'default',
      fontFamily: 'monospace'
    }}
  >
    {ta.adminStatus === 'approved' && ta.mainPassword ? '••••••••' : '••••••••'}
  </span>
</td>

                    <td>
  <span 
    title={ta.adminStatus === 'approved' && ta.investorPassword ? `Investor Password: ${ta.investorPassword}` : 'Pending approval'}
    style={{
      cursor: ta.adminStatus === 'approved' && ta.investorPassword ? 'help' : 'default',
      fontFamily: 'monospace'
    }}
  >
    {ta.adminStatus === 'approved' && ta.investorPassword ? '••••••••' : '••••••••'}
  </span>
</td>

                        <td>{account.group}</td>
                        <td>{account.balance}</td>
                        <td>{account.equity}</td>
                        <td>{account.leverage}</td>
                        <td>
                          <input type="checkbox" checked={account.liveStatus} readOnly style={{ accentColor: "#22c55e" }} />
                        </td>
                        <td>
                          <button className={styles.editAccountBtn} title="Edit" style={{ cursor: "pointer" }}>✏️</button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
{/* ✅ MY IB AREA - BLANK */}
{activeNavIndex === MYIBAREAINDEX && (
  <div className={styles.blankSection}>
    <div className={styles.sectionHeader}>
      <h2 className={styles.sectionTitle}>My IB Area</h2>
    </div>
    <div style={{ padding: '50px', textAlign: 'center', color: '#666' }}>
      Coming Soon...
    </div>
  </div>
)}

{/* ✅ SUPPORT TICKET - BLANK */}
{activeNavIndex === SUPPORTTICKETINDEX && (
  <div className={styles.blankSection}>
    <div className={styles.sectionHeader}>
      <h2 className={styles.sectionTitle}>Support Ticket</h2>
    </div>
    <div style={{ padding: '50px', textAlign: 'center', color: '#666' }}>
      Coming Soon...
    </div>
  </div>
)}

        {/* Default Dashboard Content */}
        {activeNavIndex !== TRADE_ACCOUNTS_INDEX &&
          activeNavIndex !== DEMO_ACCOUNTS_INDEX &&
          activeNavIndex !== COMMISSIONS_INDEX &&
          activeNavIndex !== REFERRALS_INDEX &&
          activeNavIndex !== DEPOSIT_INDEX &&
          activeNavIndex !== WITHDRAW_INDEX &&
          activeNavIndex !== TRANSACTIONS_INDEX &&
          activeNavIndex !== BALANCE_TRANSFER_INDEX &&
          activeNavIndex !== TWO_FA_INDEX &&
          activeNavIndex !== PROFILE_INDEX &&
          activeNavIndex !== CHANGE_PASSWORD_INDEX && 
           activeNavIndex !== MYIBAREAINDEX && 
 activeNavIndex !== SUPPORTTICKETINDEX &&(
            <>
              <div className={styles.mainHeader}>
                <div
                  className={`${styles.darkModeToggle} ${darkMode ? styles.active : ""}`}
                  onClick={toggleDarkMode}
                  role="button"
                  tabIndex={0}
                >
                  <FontAwesomeIcon icon={faSun} className={styles.sunIcon} />
                  <div className={styles.toggleSwitch}>
                    <div className={styles.toggleKnob}></div>
                  </div>
                  <FontAwesomeIcon icon={faMoon} className={styles.moonIcon} />
                  <span className={styles.darkModeLabel}>Dark Mode</span>
                </div>
                <button className={styles.unverifiedButton}>
                  {userKycStatus?.isApproved ? '✅ Verified' : 'Unverified'}
                </button>
              </div>
              
              <div className={styles.kyc}>
                <p className={styles.kycTitle}>
                  {!userKycStatus?.hasKyc && "KYC Verification required"}
                  {userKycStatus?.hasKyc && !userKycStatus.isApproved && "KYC Under Review"}
                  {userKycStatus?.isApproved && "KYC Verified ✅"}
                </p>
                <p className={styles.kycDescription}>
                  {!userKycStatus?.hasKyc && (
                    <>
                      Please submit the required KYC information to verify yourself. Otherwise, you couldn't make any withdrawal requests to the system.
                      <a
                        href="#"
                        onClick={e => {
                          e.preventDefault();
                          setShowKycForm(true);
                        }}
                      >
                        Click Here to Verify
                      </a>
                    </>
                  )}
                  {userKycStatus?.hasKyc && !userKycStatus.isApproved && "Your KYC documents are being reviewed by our admin team. You can still make withdrawals during this process."}
                  {userKycStatus?.isApproved && "Your KYC verification is complete. You can now use all withdrawal options including quick PIN-only withdrawals."}
                </p>
              </div>
              
              <div className={styles.cards}>
                <div className={styles.card}>
                  <h4>Total Deposit</h4>
 <p className={styles.bigAmount}>${totalDepositsAmount.toFixed(2)} USD</p>

                  <div className={styles.cardDetails}>
                    <div className={styles.detailItem}>
                      <span>Submitted</span>
                      <span className={styles.detailValue}>${depositStats.submitted.toFixed(2)}</span>
                    </div>
                    <div className={styles.detailItem}>
                      <span>Pending</span>
                      <span className={styles.detailValue}>${depositStats.pending.toFixed(2)}</span>
                    </div>
                    <div className={styles.detailItem}>
                      <span>Rejected</span>
                      <span className={styles.detailValue}>${depositStats.rejected.toFixed(2)}</span>
                    </div>
                  </div>
                  <div className={styles.chartPlaceholder}></div>
                </div>
                
                <div className={styles.card}>
                 <h4>Total Withdraw</h4>
                  <p className={styles.bigAmount}>${totalWithdrawalsAmount.toFixed(2)} USD</p>
                  <div className={styles.cardDetails}>
                    <div className={styles.detailItem}>
                      <span>Submitted</span>
                      <span className={styles.detailValue}>${withdrawalStats.submitted.toFixed(2)}</span>
                    </div>
                    <div className={styles.detailItem}>
                      <span>Pending</span>
                      <span className={styles.detailValue}>${withdrawalStats.pending.toFixed(2)}</span>
                    </div>
                    <div className={styles.detailItem}>
                      <span>Rejected</span>
                      <span className={styles.detailValue}>${withdrawalStats.rejected.toFixed(2)}</span>
                    </div>
                  </div>
                  <div className={styles.chartPlaceholder}></div>
                </div>
                
                <div className={styles.card}>
                 <h4>Total Trading Account Balance</h4>
                 <p className={styles.bigAmount}>${totalTradingAccountBalance.toFixed(2)} USD</p>

                   <div className={styles.cardDetails}>
    <div className={styles.detailItem}>
      <span>Account Balance</span>
      <span className={styles.detailValue}>${totalAccountBalance.toFixed(2)}</span>
    </div>
    <div className={styles.detailItem}>
      <span>Free Margin</span>
      <span className={styles.detailValue}>${totalAccountFreeMargin.toFixed(2)}</span>
    </div>
  </div>
                 <div className={styles.cardDetails}>
                    <div className={styles.detailItem}>
                      <span>Approved Accounts</span>
                      <span className={styles.detailValue}>
                        {tradeAccounts.filter(acc => acc.adminStatus === 'approved').length}
                      </span>
                    </div>
                    <div className={styles.detailItem}>
                      <span>Pending Approval</span>
                      <span className={styles.detailValue}>
                        {tradeAccounts.filter(acc => acc.adminStatus === 'pending' || !acc.adminStatus).length}
                      </span>
                    </div>
                  </div>
                  <div className={styles.chartPlaceholder}></div>
                </div>
              </div>
              
              <div className={styles.dashboardGrid}>
                <div className={styles.tradingSummary}>
                  <h2 className={styles.sectionTitle}>Trading A/c Summary</h2>
                  <table className={styles.accountTable}>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Account</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Server</th>
                        <th>Balance</th>
                        <th>Equity</th>
                        <th>Free Margin</th>
                        <th>Live Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tradeAccounts.length === 0 ? (
                        <tr>
                          <td colSpan={9} style={{ textAlign: "center", color: "#adb7bd", padding: "20px 0" }}>
                            No trading accounts found
                          </td>
                        </tr>
                      ) : (
                        tradeAccounts.map((account, index) => (
                          <tr key={account.accountId}>
                            <td>{index + 1}</td>
                            <td>{account.accountId}</td>
                            <td>
                              <span className={styles.accountTypeDisplay}>
                                Real
                                {account.accountType?.toLowerCase().includes('algo') && (
                                  <span className={styles.algoIcon} title="Algo Trading Account">
                                    <FontAwesomeIcon icon={faRobot} style={{marginLeft: '6px', color: '#10b981', fontSize: '12px'}} />
                                  </span>
                                )}
                              </span>
                            </td>
                            <td>
                              <span className={`${styles.statusBadge} ${styles[account.adminStatus || 'pending']}`}>
                                {account.adminStatus === 'approved' && '✅ Approved'}
                                {account.adminStatus === 'rejected' && '❌ Rejected'}
                                {(!account.adminStatus || account.adminStatus === 'pending') && '⏳ Pending'}
                              </span>
                            </td>
                            <td>{account.server}</td>
                            <td>${parseFloat(account.balance || 0).toFixed(2)}</td>
                            <td>${(parseFloat(account.balance || 0) + parseFloat(account.credit || 0)).toFixed(2)}</td>
                            <td>${parseFloat(account.freeMargin || account.equity || account.balance || 0).toLocaleString()}</td>
                            <td>
                              <input 
                                type="checkbox" 
                                checked={account.adminStatus === 'approved'} 
                                readOnly 
                                style={{ accentColor: "#22c55e" }} 
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                <div className={styles.mt5Card}>
                  <div className={styles.mt5Header}>
                    <h3 className={styles.mt5Title}>🚀 Start Trading</h3>
                  </div>
                  <p style={{ fontSize: '0.85rem', color: '#6b7280', marginBottom: '16px', textAlign: 'center' }}>
                    Access your trading platform instantly
                  </p>
                  <div className={styles.mt5DownloadGrid} style={{ gridTemplateColumns: '1fr' }}>
                    <div className={styles.mt5DownloadItem}>
                      <div className={styles.mt5PlatformIconContainer}>
                        <FontAwesomeIcon icon={faGlobe} className={styles.mt5PlatformIcon} />
                      </div>
                      <span className={styles.mt5Platform}>Web Trader</span>
                      <button
                        onClick={handleMetaTraderLogin}
                        className={`${styles.mt5Download} ${styles.mt5LaunchButton}`}
                        style={{
                          background: '#4CAF50', color: 'white', border: 'none',
                          cursor: 'pointer', transition: 'all 0.2s ease', fontWeight: 'bold',
                          padding: '8px 16px', borderRadius: '6px'
                        }}
                        onMouseOver={(e) => e.target.style.background = '#45a049'}
                        onMouseOut={(e) => e.target.style.background = '#4CAF50'}
                      >
                        <FontAwesomeIcon icon={faPlay} style={{ marginRight: '6px' }} />
                        LAUNCH
                      </button>
                    </div>

                    <div className={styles.mt5DownloadItem}>
                      <div className={styles.mt5PlatformIconContainer}>
                        <FontAwesomeIcon icon={faMobileAlt} className={styles.mt5PlatformIcon} />
                      </div>
                      <span className={styles.mt5Platform}>Mobile App</span>
                      
                        <a href="/stoneforex.apk"
                        download
                        className={styles.mt5Download}
                        style={{ fontWeight: 'bold' }}
                      >
                        <FontAwesomeIcon icon={faDownload} style={{ marginRight: '6px' }} />
                        APK
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
     </main>
     {/* ✅ CRYPTO USDT MODAL */}
{showCryptoModal && (
  <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 16 }}>
    <div style={{ background: '#0f172a', borderRadius: 20, width: '100%', maxWidth: 480, padding: '0 0 28px 0', boxShadow: '0 24px 80px rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.08)', overflow: 'hidden', position: 'relative', maxHeight: '90vh', overflowY: 'auto' }}>
      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #1a1f3a 0%, #0d1117 100%)', padding: '22px 28px 18px', borderBottom: '1px solid rgba(255,255,255,0.07)', position: 'sticky', top: 0, zIndex: 2 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ margin: 0, color: '#fff', fontSize: 20, fontWeight: 700 }}>₿ Deposit via Crypto USDT</h2>
            <p style={{ margin: '4px 0 0', color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>Send USDT to the address below</p>
          </div>
          <button onClick={() => { setShowCryptoModal(false); setDepositForm(f => ({...f, gateway: ''})); }}
            style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff', width: 36, height: 36, borderRadius: 10, cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
        </div>
      </div>

      <div style={{ padding: '24px 28px 0' }}>
        {cryptoLoading ? (
          <div style={{ textAlign: 'center', padding: '40px 0', color: 'rgba(255,255,255,0.5)' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>⏳</div>
            <p>Loading crypto details...</p>
          </div>
        ) : !cryptoAvailable ? (
          <div style={{ textAlign: 'center', padding: '36px 0' }}>
            <div style={{ fontSize: 52, marginBottom: 16 }}>🔐</div>
            <h3 style={{ color: '#fff', margin: '0 0 10px', fontWeight: 700, fontSize: 18 }}>Crypto — Currently Unavailable</h3>
            <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14, lineHeight: 1.6, margin: '0 auto', maxWidth: 320 }}>
              Our crypto channel is being set up. Please use another payment method.
            </p>
            <button onClick={() => { setShowCryptoModal(false); setDepositForm(f => ({...f, gateway: ''})); }}
              style={{ marginTop: 24, background: 'rgba(255,255,255,0.1)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)', padding: '10px 24px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
              Choose Another Method
            </button>
          </div>
        ) : selectedCryptoGateway && (
          <>
            {/* Network selector if multiple */}
            {cryptoGateways.length > 1 && (
              <div style={{ marginBottom: 20 }}>
                <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, fontWeight: 600, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Select Network</p>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {cryptoGateways.map(gw => (
                    <button key={gw.id} onClick={() => setSelectedCryptoGateway(gw)}
                      style={{ padding: '8px 20px', borderRadius: 8, border: `2px solid ${selectedCryptoGateway.id === gw.id ? '#f59e0b' : 'rgba(255,255,255,0.15)'}`, background: selectedCryptoGateway.id === gw.id ? 'rgba(245,158,11,0.15)' : 'transparent', color: '#fff', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>
                      {gw.network}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Amount */}
            <div style={{ background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.25)', borderRadius: 12, padding: '14px 18px', marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14 }}>You are sending</span>
              <span style={{ color: '#f59e0b', fontSize: 22, fontWeight: 800 }}>${depositForm.amount || '0'} USDT</span>
            </div>

            {/* QR Code */}
            {selectedCryptoGateway.qrCodeUrl && (
              <div style={{ textAlign: 'center', marginBottom: 20 }}>
                <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12, marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Scan QR Code</p>
                <div style={{ background: '#fff', borderRadius: 12, padding: 12, display: 'inline-block' }}>
                  <img src={selectedCryptoGateway.qrCodeUrl} alt="Crypto QR" style={{ width: 160, height: 160, display: 'block' }} />
                </div>
                <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 12, marginTop: 8 }}>Or copy address below</p>
              </div>
            )}

            {/* Wallet Address */}
            <div style={{ marginBottom: 20 }}>
              <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12, fontWeight: 600, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Wallet Address</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'rgba(255,255,255,0.05)', borderRadius: 10, padding: '12px 14px', border: '1px solid rgba(255,255,255,0.1)' }}>
                <span style={{ flex: 1, color: '#e2e8f0', fontSize: 13, fontFamily: 'monospace', wordBreak: 'break-all' }}>{selectedCryptoGateway.walletAddress}</span>
                <button onClick={() => { navigator.clipboard.writeText(selectedCryptoGateway.walletAddress); setCopiedCryptoAddress(true); setTimeout(() => setCopiedCryptoAddress(false), 2500); }}
                  style={{ background: copiedCryptoAddress ? 'rgba(16,185,129,0.2)' : 'rgba(245,158,11,0.2)', color: copiedCryptoAddress ? '#10b981' : '#f59e0b', border: `1px solid ${copiedCryptoAddress ? '#10b981' : '#f59e0b'}`, padding: '8px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 700, transition: 'all 0.2s', whiteSpace: 'nowrap' }}>
                  {copiedCryptoAddress ? '✓ Copied!' : '📋 Copy'}
                </button>
              </div>
            </div>

            {/* Details Grid */}
            <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 12, padding: '14px 18px', marginBottom: 16 }}>
              {[
                ['Network', selectedCryptoGateway.network],
                ['Minimum Deposit', `$${selectedCryptoGateway.minimumDeposit} USDT`],
                ['Estimated Credit Time', selectedCryptoGateway.estimatedCreditTime],
              ].map(([k, v]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                  <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>{k}</span>
                  <span style={{ color: '#f59e0b', fontWeight: 700, fontSize: 13 }}>{v}</span>
                </div>
              ))}
            </div>

            {selectedCryptoGateway.note && (
              <div style={{ background: 'rgba(59,130,246,0.08)', border: '1px solid rgba(59,130,246,0.2)', borderRadius: 10, padding: '12px 16px', marginBottom: 16 }}>
                <p style={{ margin: 0, color: 'rgba(255,255,255,0.65)', fontSize: 13 }}>ℹ️ {selectedCryptoGateway.note}</p>
              </div>
            )}

            <div style={{ background: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.2)', borderRadius: 10, padding: '12px 16px', marginBottom: 4 }}>
              <p style={{ margin: 0, color: 'rgba(255,255,255,0.6)', fontSize: 13, lineHeight: 1.55 }}>
                ✅ After sending USDT, close this and upload your transaction screenshot to submit the deposit request.
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  </div>
)}
{/* ✅ BANK TRANSFER MODAL */}
{showBankModal && (
  <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 16 }}>
    <div style={{ background: '#0f172a', borderRadius: 20, width: '100%', maxWidth: 480, padding: '0 0 28px 0', boxShadow: '0 24px 80px rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.08)', overflow: 'hidden', position: 'relative' }}>
      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #1e3a5f 0%, #0f2744 100%)', padding: '22px 28px 18px', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ margin: 0, color: '#fff', fontSize: 20, fontWeight: 700 }}>🏦 Deposit via Bank Transfer</h2>
            <p style={{ margin: '4px 0 0', color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>NEFT / RTGS / IMPS</p>
          </div>
          <button onClick={() => { setShowBankModal(false); setDepositForm(f => ({...f, gateway: ''})); }}
            style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff', width: 36, height: 36, borderRadius: 10, cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
        </div>
      </div>

      <div style={{ padding: '24px 28px 0' }}>
        {bankLoading ? (
          <div style={{ textAlign: 'center', padding: '40px 0', color: 'rgba(255,255,255,0.5)' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>⏳</div>
            <p>Loading bank details...</p>
          </div>
        ) : !bankAvailable ? (
          <div style={{ textAlign: 'center', padding: '36px 0' }}>
            <div style={{ fontSize: 52, marginBottom: 16 }}>🏗️</div>
            <h3 style={{ color: '#fff', margin: '0 0 10px', fontWeight: 700, fontSize: 18 }}>Bank Transfer — Currently Unavailable</h3>
            <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14, lineHeight: 1.6, margin: '0 auto', maxWidth: 320 }}>
              Our bank transfer channel is being set up for your region. This is typically activated within 24–48 hours.
            </p>
            <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: 13, marginTop: 16 }}>Please use another payment method or contact support.</p>
            <button onClick={() => { setShowBankModal(false); setDepositForm(f => ({...f, gateway: ''})); }}
              style={{ marginTop: 24, background: 'rgba(255,255,255,0.1)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)', padding: '10px 24px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
              Choose Another Method
            </button>
          </div>
        ) : (
          <>
            {/* Multiple bank selector */}
            {bankGateways.length > 1 && (
              <div style={{ marginBottom: 20 }}>
                <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, fontWeight: 600, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Select Bank Account</p>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {bankGateways.map(gw => (
                    <button key={gw.id} onClick={() => setSelectedBankGateway(gw)}
                      style={{ padding: '8px 16px', borderRadius: 8, border: `2px solid ${selectedBankGateway?.id === gw.id ? '#3b82f6' : 'rgba(255,255,255,0.15)'}`, background: selectedBankGateway?.id === gw.id ? 'rgba(59,130,246,0.15)' : 'transparent', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                      {gw.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {selectedBankGateway && (
              <>
                {/* Bank details table */}
                <div style={{ background: 'rgba(255,255,255,0.05)', borderRadius: 12, padding: '18px 20px', marginBottom: 20, border: '1px solid rgba(255,255,255,0.08)' }}>
                  {[
                    ['Account Name', selectedBankGateway.accountName],
                    ['Account Number', selectedBankGateway.accountNumber],
                    ['Bank Name', selectedBankGateway.bankName],
                    ['IFSC Code', selectedBankGateway.ifscCode],
                    ['Account Type', selectedBankGateway.accountType],
                  ].map(([label, value]) => (
                    <div key={label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                      <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>{label}</span>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ color: '#fff', fontWeight: 600, fontSize: 14 }}>{value}</span>
                        <button onClick={() => navigator.clipboard.writeText(value)}
                          style={{ background: 'rgba(255,255,255,0.08)', border: 'none', color: 'rgba(255,255,255,0.5)', padding: '3px 8px', borderRadius: 5, cursor: 'pointer', fontSize: 11 }}>Copy</button>
                      </div>
                    </div>
                  ))}
                </div>
                {selectedBankGateway.note && (
                  <div style={{ background: 'rgba(59,130,246,0.1)', border: '1px solid rgba(59,130,246,0.3)', borderRadius: 10, padding: '12px 16px', marginBottom: 20 }}>
                    <p style={{ margin: 0, color: 'rgba(255,255,255,0.7)', fontSize: 13 }}>ℹ️ {selectedBankGateway.note}</p>
                  </div>
                )}
                <div style={{ background: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.2)', borderRadius: 10, padding: '12px 16px', marginBottom: 20 }}>
                  <p style={{ margin: 0, color: 'rgba(255,255,255,0.65)', fontSize: 13 }}>
                    ✅ After the transfer, click <b style={{ color: '#fff' }}>"I have paid"</b> below and upload your payment screenshot with UTR/Reference number.
                  </p>
                </div>
                <button onClick={() => setShowBankModal(false)}
                  style={{ width: '100%', background: 'linear-gradient(135deg, #1d4ed8, #2563eb)', color: '#fff', border: 'none', padding: '14px', borderRadius: 12, cursor: 'pointer', fontWeight: 700, fontSize: 15, marginBottom: 4 }}>
                  ✅ I Have Paid — Upload Receipt
                </button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  </div>
)}
      {/* ✅ UPI PAYMENT MODAL */}
      {showUpiModal && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 9999, padding: 16
        }}>
          <div style={{
            background: '#0f172a', borderRadius: 20, width: '100%', maxWidth: 480,
            padding: '0 0 28px 0', boxShadow: '0 24px 80px rgba(0,0,0,0.5)',
            border: '1px solid rgba(255,255,255,0.08)', overflow: 'hidden', position: 'relative'
          }}>
            {/* Header */}
            <div style={{
              background: 'linear-gradient(135deg, #1e3a5f 0%, #0f2744 100%)',
              padding: '22px 28px 18px', borderBottom: '1px solid rgba(255,255,255,0.07)'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <h2 style={{ margin: 0, color: '#fff', fontSize: 20, fontWeight: 700, letterSpacing: '-0.3px' }}>
                    🇮🇳 Deposit Using UPI
                  </h2>
                  <p style={{ margin: '4px 0 0', color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>
                    Instant transfer using any UPI app
                  </p>
                </div>
                <button onClick={() => { setShowUpiModal(false); setDepositForm(f => ({...f, gateway: ''})); }}
                  style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff', width: 36, height: 36, borderRadius: 10, cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  ✕
                </button>
              </div>
            </div>

            <div style={{ padding: '24px 28px 0' }}>
              {upiLoading ? (
                <div style={{ textAlign: 'center', padding: '40px 0', color: 'rgba(255,255,255,0.5)' }}>
                  <div style={{ fontSize: 32, marginBottom: 12 }}>⏳</div>
                  <p>Loading payment details...</p>
                </div>
              ) : !upiAvailable ? (
                // Professional "unavailable" state — doesn't imply admin blocked
                <div style={{ textAlign: 'center', padding: '36px 0' }}>
                  <div style={{ fontSize: 52, marginBottom: 16 }}>🔄</div>
                  <h3 style={{ color: '#fff', margin: '0 0 10px', fontWeight: 700, fontSize: 18 }}>
                    UPI Payments — Temporary Setup
                  </h3>
                  <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14, lineHeight: 1.6, margin: '0 auto', maxWidth: 320 }}>
                    Our UPI payment channel is currently being configured for your account. This is typically completed within 24 hours.
                  </p>
                  <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: 13, marginTop: 16 }}>
                    Please try another payment method or contact support.
                  </p>
                  <button onClick={() => { setShowUpiModal(false); setDepositForm(f => ({...f, gateway: ''})); }}
                    style={{ marginTop: 24, background: 'rgba(255,255,255,0.1)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)', padding: '10px 24px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
                    Choose Another Method
                  </button>
                </div>
              ) : (
                <>
                  {/* Gateway selector if multiple */}
                  {upiGateways.length > 1 && (
                    <div style={{ marginBottom: 20 }}>
                      <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, fontWeight: 600, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Select Payment Account</p>
                      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        {upiGateways.map(gw => (
                          <button key={gw.id} onClick={() => setSelectedUpiGateway(gw)}
                            style={{ padding: '8px 16px', borderRadius: 8, border: `2px solid ${selectedUpiGateway?.id === gw.id ? '#3b82f6' : 'rgba(255,255,255,0.15)'}`, background: selectedUpiGateway?.id === gw.id ? 'rgba(59,130,246,0.15)' : 'transparent', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600, transition: 'all 0.15s' }}>
                            {gw.label}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {selectedUpiGateway && (
                    <>
                      {/* Merchant info */}
                      <div style={{ background: 'rgba(255,255,255,0.05)', borderRadius: 12, padding: '14px 18px', marginBottom: 20, border: '1px solid rgba(255,255,255,0.08)' }}>
                        <p style={{ margin: 0, color: 'rgba(255,255,255,0.5)', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.8px', fontWeight: 600 }}>Merchant</p>
                        <p style={{ margin: '4px 0 0', color: '#fff', fontWeight: 700, fontSize: 16 }}>{selectedUpiGateway.merchantName}</p>
                      </div>
{/* Amount display if admin configured it */}
                      {selectedUpiGateway.amountDisplay && selectedUpiGateway.amountDisplay !== 'none' && (
                        <div style={{ display: 'flex', gap: 10, marginBottom: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
                          {(selectedUpiGateway.amountDisplay === 'usd_only' || selectedUpiGateway.amountDisplay === 'both') && selectedUpiGateway.amountUSD && (
                            <div style={{ background: 'rgba(59,130,246,0.12)', border: '1px solid rgba(59,130,246,0.3)', borderRadius: 10, padding: '10px 20px', textAlign: 'center' }}>
                              <p style={{ margin: 0, color: 'rgba(255,255,255,0.5)', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.8px' }}>Amount (USD)</p>
                              <p style={{ margin: '4px 0 0', color: '#93c5fd', fontWeight: 800, fontSize: 22 }}>${Number(selectedUpiGateway.amountUSD).toLocaleString()}</p>
                            </div>
                          )}
                          {(selectedUpiGateway.amountDisplay === 'inr_only' || selectedUpiGateway.amountDisplay === 'both') && selectedUpiGateway.amountINR && (
                            <div style={{ background: 'rgba(251,191,36,0.1)', border: '1px solid rgba(251,191,36,0.25)', borderRadius: 10, padding: '10px 20px', textAlign: 'center' }}>
                              <p style={{ margin: 0, color: 'rgba(255,255,255,0.5)', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.8px' }}>Amount (INR)</p>
                              <p style={{ margin: '4px 0 0', color: '#fcd34d', fontWeight: 800, fontSize: 22 }}>₹{Number(selectedUpiGateway.amountINR).toLocaleString()}</p>
                            </div>
                          )}
                        </div>
                      )}
                      {selectedUpiGateway.amountNote && (
                        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.4)', fontSize: 12, margin: '-10px 0 16px' }}>{selectedUpiGateway.amountNote}</p>
                      )}
                      {/* QR Code */}
                      {selectedUpiGateway.qrCodeUrl ? (
                        <div style={{ textAlign: 'center', marginBottom: 20 }}>
                          <div style={{ display: 'inline-block', background: '#fff', padding: 14, borderRadius: 16, boxShadow: '0 8px 32px rgba(0,0,0,0.3)' }}>
                            <img src={selectedUpiGateway.qrCodeUrl} alt="UPI QR Code"
                              style={{ width: 180, height: 180, display: 'block', borderRadius: 6 }} />
                          </div>
                          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, marginTop: 12 }}>
                            📱 Scan with any UPI app
                          </p>
                        </div>
                      ) : (
                        <div style={{ textAlign: 'center', padding: '20px 0', marginBottom: 8 }}>
                          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14 }}>QR Code coming soon — use UPI ID below</p>
                        </div>
                      )}

                      {/* Divider */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                        <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.1)' }} />
                        <span style={{ color: 'rgba(255,255,255,0.35)', fontSize: 12, fontWeight: 600 }}>OR ENTER UPI ID</span>
                        <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.1)' }} />
                      </div>

                      {/* UPI ID Copy */}
                      <div style={{ background: 'rgba(255,255,255,0.05)', borderRadius: 12, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid rgba(255,255,255,0.1)', marginBottom: 16 }}>
                        <div>
                          <p style={{ margin: 0, color: 'rgba(255,255,255,0.4)', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.8px' }}>UPI ID</p>
                          <p style={{ margin: '3px 0 0', color: '#e2e8f0', fontWeight: 600, fontSize: 15, letterSpacing: '0.2px' }}>{selectedUpiGateway.upiId}</p>
                        </div>
                        <button onClick={() => { navigator.clipboard.writeText(selectedUpiGateway.upiId); setCopiedUpiId(true); setTimeout(() => setCopiedUpiId(false), 2000); }}
                          style={{ background: copiedUpiId ? 'rgba(16,185,129,0.2)' : 'rgba(59,130,246,0.2)', color: copiedUpiId ? '#10b981' : '#3b82f6', border: `1px solid ${copiedUpiId ? '#10b981' : '#3b82f6'}`, padding: '8px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 700, transition: 'all 0.2s' }}>
                          {copiedUpiId ? '✓ Copied!' : '📋 Copy'}
                        </button>
                      </div>

                      {/* Info note */}
                      {selectedUpiGateway.note && (
                        <div style={{ background: 'rgba(59,130,246,0.08)', border: '1px solid rgba(59,130,246,0.2)', borderRadius: 10, padding: '12px 16px', marginBottom: 16 }}>
                          <p style={{ margin: 0, color: 'rgba(255,255,255,0.65)', fontSize: 13 }}>
                            ℹ️ {selectedUpiGateway.note}
                          </p>
                        </div>
                      )}

                      {/* ✅ Payment Proof Section */}
{!slipSubmitted ? (
  <div style={{ background: 'rgba(16,185,129,0.06)', border: '1px solid rgba(16,185,129,0.25)', borderRadius: 12, padding: '16px', marginTop: 8 }}>
    <p style={{ margin: '0 0 12px', color: '#10b981', fontSize: 13, fontWeight: 700 }}>
      📋 After paying, confirm your payment below:
    </p>

    {/* UTR input */}
    <div style={{ marginBottom: 10 }}>
      <p style={{ margin: '0 0 5px', color: 'rgba(255,255,255,0.5)', fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.6px' }}>
        UTR / Reference Number
      </p>
      <input
        type="text"
        placeholder="e.g. 425316789012"
        value={utrNumber}
        onChange={(e) => setUtrNumber(e.target.value)}
        style={{
          width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.15)',
          background: 'rgba(255,255,255,0.07)', color: '#fff', fontSize: 14, boxSizing: 'border-box'
        }}
      />
    </div>

    {/* Slip upload */}
    <div style={{ marginBottom: 12 }}>
      <p style={{ margin: '0 0 5px', color: 'rgba(255,255,255,0.5)', fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.6px' }}>
        Payment Screenshot (optional)
      </p>
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setUtrSlip(e.target.files[0])}
        style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, width: '100%' }}
      />
      {utrSlip && (
        <p style={{ margin: '4px 0 0', color: '#10b981', fontSize: 12 }}>✓ {utrSlip.name}</p>
      )}
    </div>

    <button
      onClick={handleSubmitPaymentProof}
      disabled={slipUploading}
      style={{
        width: '100%', padding: '12px', borderRadius: 10, border: 'none',
        background: slipUploading ? 'rgba(16,185,129,0.4)' : 'linear-gradient(135deg, #10b981, #059669)',
        color: '#fff', fontWeight: 700, fontSize: 15, cursor: slipUploading ? 'not-allowed' : 'pointer'
      }}
    >
      {slipUploading ? '⏳ Submitting...' : '✅ Confirm Payment'}
    </button>
  </div>
) : (
  <div style={{ background: 'rgba(16,185,129,0.1)', border: '1px solid #10b981', borderRadius: 12, padding: '16px', textAlign: 'center', marginTop: 8 }}>
    <p style={{ margin: 0, color: '#10b981', fontWeight: 700, fontSize: 15 }}>✅ Payment confirmed!</p>
    <p style={{ margin: '6px 0 0', color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>Admin will review and approve shortly.</p>
  </div>
)}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default DashboardPage;